angular.module('DssMainApp').service("DssMainApplicationsDataService", [function () {

    this.getIrrigationFieldPlotCropData = function () {
        return [
            {
                "plot_slug": "e63230d4-cee0-11e5-81e8-f23c9184cad6",
                "plot_name": "Shrubhill Farms - M18 - 2016-17-0157 - Potato - Infinity",
                "plot_area": 3.13,
                "et_seasonal": 30.13,
                "rainfall_effective": 10.13,
                "irrigation_applied": 20,
                "irrigation_required": 20,
                "sowing_date_actual": 50,
                "harvest_date_expected": 50,
                "yield_predicted": 50,
                "yield_estimated": 50,
                "model_options": "Crop Stress: Linear Model , Effective Rainfall: USDA SCS , Root Growth: Sigmoidal Model",
                "status": 2,
            },
            {
                "plot_slug": "e63230d4-cee0-11e5-81e8-f23c9184cad6",
                "plot_name": "Shrubhill Farms - C7 - 2016-17-0165 - Potato - Infinity",
                "plot_area": 3.13,
                "et_seasonal": 30.13,
                "rainfall_effective": 10.13,
                "irrigation_applied": 20,
                "irrigation_required": 20,
                "sowing_date_actual": 50,
                "harvest_date_expected": 50,
                "yield_predicted": 50,
                "yield_estimated": 50,
                "model_options": "Crop Stress: Linear Model , Effective Rainfall: USDA SCS , Root Growth: Sigmoidal Model",
                "status": 2,
            },
            {
                "plot_slug": "e63230d4-cee0-11e5-81e8-f23c9184cad6",
                "plot_name": "Shrubhill Farms - P69 - 2016-17-0025 - Potato - Arsenal",
                "plot_area": 3.13,
                "et_seasonal": 30.13,
                "rainfall_effective": 10.13,
                "irrigation_applied": 20,
                "irrigation_required": 20,
                "sowing_date_actual": 50,
                "harvest_date_expected": 50,
                "yield_predicted": 50,
                "yield_estimated": 50,
                 "model_options": "Crop Stress: Linear Model , Effective Rainfall: USDA SCS , Root Growth: Sigmoidal Model",
                "status": 2,
            },
        ];
    };

    this.getIrrigationData = function () {
        return[{"date":"13/10/2015","moisture_depletion":0,"actual_et":0,"reference_et":0.12,"crop_coefficient":0.7,"crop_stress":0,"et_correction_coefficient":0,"root_depth":0.38,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.08},
{"date":"14/10/2015","moisture_depletion":0,"actual_et":0.06,"reference_et":0.09,"crop_coefficient":0.7,"crop_stress":0.99,"et_correction_coefficient":0,"root_depth":0.5,"applied_irrigation":0,"effective_rainfall":0.1,"irrigation_requirement":0.06},
{"date":"15/10/2015","moisture_depletion":0,"actual_et":0.09,"reference_et":0.11,"crop_coefficient":0.7,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":0.63,"applied_irrigation":0,"effective_rainfall":0.1,"irrigation_requirement":0.08},
{"date":"16/10/2015","moisture_depletion":0,"actual_et":0.09,"reference_et":0.1,"crop_coefficient":0.7,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":0.78,"applied_irrigation":0,"effective_rainfall":0.09,"irrigation_requirement":0.07},
{"date":"17/10/2015","moisture_depletion":0,"actual_et":0.06,"reference_et":0.07,"crop_coefficient":0.7,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":0.94,"applied_irrigation":0,"effective_rainfall":0.19,"irrigation_requirement":0.05},
{"date":"18/10/2015","moisture_depletion":0.09,"actual_et":0.09,"reference_et":0.1,"crop_coefficient":0.7,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":1.12,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.07},
{"date":"19/10/2015","moisture_depletion":0.17,"actual_et":0.08,"reference_et":0.1,"crop_coefficient":0.7,"crop_stress":1,"et_correction_coefficient":0.5,"root_depth":1.31,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.07},
{"date":"20/10/2015","moisture_depletion":0,"actual_et":0.04,"reference_et":0.05,"crop_coefficient":0.7,"crop_stress":1,"et_correction_coefficient":0.3,"root_depth":1.52,"applied_irrigation":0,"effective_rainfall":0.92,"irrigation_requirement":0.04},
{"date":"21/10/2015","moisture_depletion":0.12,"actual_et":0.12,"reference_et":0.14,"crop_coefficient":0.7,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":1.75,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.1},
{"date":"22/10/2015","moisture_depletion":0.2,"actual_et":0.07,"reference_et":0.09,"crop_coefficient":0.7,"crop_stress":1,"et_correction_coefficient":0.5,"root_depth":1.99,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.06},
{"date":"23/10/2015","moisture_depletion":0,"actual_et":0.06,"reference_et":0.08,"crop_coefficient":0.7,"crop_stress":1,"et_correction_coefficient":0.3,"root_depth":2.24,"applied_irrigation":0,"effective_rainfall":0.47,"irrigation_requirement":0.05},
{"date":"24/10/2015","moisture_depletion":0,"actual_et":0.07,"reference_et":0.08,"crop_coefficient":0.7,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":2.51,"applied_irrigation":0,"effective_rainfall":0.16,"irrigation_requirement":0.05},
{"date":"25/10/2015","moisture_depletion":0,"actual_et":0,"reference_et":0,"crop_coefficient":0.7,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":2.8,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0},
{"date":"26/10/2015","moisture_depletion":0.07,"actual_et":0.07,"reference_et":0.08,"crop_coefficient":0.7,"crop_stress":1,"et_correction_coefficient":0.5,"root_depth":3.1,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.06},
{"date":"27/10/2015","moisture_depletion":0,"actual_et":0.06,"reference_et":0.08,"crop_coefficient":0.7,"crop_stress":1,"et_correction_coefficient":0.3,"root_depth":3.41,"applied_irrigation":0,"effective_rainfall":0.24,"irrigation_requirement":0.05},
{"date":"28/10/2015","moisture_depletion":0,"actual_et":0.04,"reference_et":0.05,"crop_coefficient":0.7,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":3.74,"applied_irrigation":0,"effective_rainfall":0.23,"irrigation_requirement":0.04},
{"date":"29/10/2015","moisture_depletion":0.03,"actual_et":0.05,"reference_et":0.06,"crop_coefficient":0.7,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":4.09,"applied_irrigation":0,"effective_rainfall":0.03,"irrigation_requirement":0.04},
{"date":"30/10/2015","moisture_depletion":0,"actual_et":0.08,"reference_et":0.09,"crop_coefficient":0.7,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":4.45,"applied_irrigation":0,"effective_rainfall":0.93,"irrigation_requirement":0.06},
{"date":"31/10/2015","moisture_depletion":0.06,"actual_et":0.06,"reference_et":0.07,"crop_coefficient":0.7,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":4.82,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.05},
{"date":"01/11/2015","moisture_depletion":0.11,"actual_et":0.05,"reference_et":0.06,"crop_coefficient":0.7,"crop_stress":1,"et_correction_coefficient":0.5,"root_depth":5.21,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.04},
{"date":"02/11/2015","moisture_depletion":0.12,"actual_et":0.02,"reference_et":0.02,"crop_coefficient":0.7,"crop_stress":1,"et_correction_coefficient":0.3,"root_depth":5.61,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.02},
{"date":"03/11/2015","moisture_depletion":0.15,"actual_et":0.03,"reference_et":0.04,"crop_coefficient":0.7,"crop_stress":1,"et_correction_coefficient":0,"root_depth":6.03,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.03},
{"date":"04/11/2015","moisture_depletion":0,"actual_et":0.02,"reference_et":0.03,"crop_coefficient":0.7,"crop_stress":1,"et_correction_coefficient":0,"root_depth":6.46,"applied_irrigation":0,"effective_rainfall":0.63,"irrigation_requirement":0.02},
{"date":"05/11/2015","moisture_depletion":0,"actual_et":0.04,"reference_et":0.05,"crop_coefficient":0.7,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":6.91,"applied_irrigation":0,"effective_rainfall":0.31,"irrigation_requirement":0.04},
{"date":"06/11/2015","moisture_depletion":0,"actual_et":0.05,"reference_et":0.06,"crop_coefficient":0.7,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":7.37,"applied_irrigation":0,"effective_rainfall":0.35,"irrigation_requirement":0.04},
{"date":"07/11/2015","moisture_depletion":0,"actual_et":0.08,"reference_et":0.09,"crop_coefficient":0.7,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":7.85,"applied_irrigation":0,"effective_rainfall":0.23,"irrigation_requirement":0.07},
{"date":"08/11/2015","moisture_depletion":0.05,"actual_et":0.05,"reference_et":0.06,"crop_coefficient":0.7,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":8.34,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.04},
{"date":"09/11/2015","moisture_depletion":0.15,"actual_et":0.1,"reference_et":0.13,"crop_coefficient":0.7,"crop_stress":1,"et_correction_coefficient":0.5,"root_depth":8.84,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.09},
{"date":"10/11/2015","moisture_depletion":0.2,"actual_et":0.07,"reference_et":0.1,"crop_coefficient":0.7,"crop_stress":1,"et_correction_coefficient":0.3,"root_depth":9.35,"applied_irrigation":0,"effective_rainfall":0.03,"irrigation_requirement":0.07},
{"date":"11/11/2015","moisture_depletion":0.3,"actual_et":0.1,"reference_et":0.12,"crop_coefficient":0.7,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":9.88,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.08},
{"date":"12/11/2015","moisture_depletion":0.36,"actual_et":0.06,"reference_et":0.07,"crop_coefficient":0.7,"crop_stress":1,"et_correction_coefficient":0.5,"root_depth":10.43,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.05},
{"date":"13/11/2015","moisture_depletion":0.4,"actual_et":0.14,"reference_et":0.18,"crop_coefficient":0.7,"crop_stress":1,"et_correction_coefficient":0.3,"root_depth":10.99,"applied_irrigation":0,"effective_rainfall":0.1,"irrigation_requirement":0.13},
{"date":"14/11/2015","moisture_depletion":0.08,"actual_et":0.06,"reference_et":0.08,"crop_coefficient":0.71,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":11.56,"applied_irrigation":0,"effective_rainfall":0.38,"irrigation_requirement":0.05},
{"date":"15/11/2015","moisture_depletion":0.25,"actual_et":0.17,"reference_et":0.2,"crop_coefficient":0.71,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":12.14,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.14},
{"date":"16/11/2015","moisture_depletion":0.29,"actual_et":0.09,"reference_et":0.11,"crop_coefficient":0.71,"crop_stress":1,"et_correction_coefficient":0.5,"root_depth":12.74,"applied_irrigation":0,"effective_rainfall":0.05,"irrigation_requirement":0.08},
{"date":"17/11/2015","moisture_depletion":0.32,"actual_et":0.13,"reference_et":0.15,"crop_coefficient":0.71,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":13.35,"applied_irrigation":0,"effective_rainfall":0.09,"irrigation_requirement":0.1},
{"date":"18/11/2015","moisture_depletion":0.35,"actual_et":0.15,"reference_et":0.17,"crop_coefficient":0.72,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":13.97,"applied_irrigation":0,"effective_rainfall":0.12,"irrigation_requirement":0.12},
{"date":"19/11/2015","moisture_depletion":0.39,"actual_et":0.08,"reference_et":0.09,"crop_coefficient":0.72,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":14.6,"applied_irrigation":0,"effective_rainfall":0.04,"irrigation_requirement":0.06},
{"date":"20/11/2015","moisture_depletion":0.45,"actual_et":0.06,"reference_et":0.07,"crop_coefficient":0.72,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":15.25,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.05},
{"date":"21/11/2015","moisture_depletion":0,"actual_et":0.06,"reference_et":0.08,"crop_coefficient":0.72,"crop_stress":1,"et_correction_coefficient":0.5,"root_depth":15.91,"applied_irrigation":0,"effective_rainfall":0.54,"irrigation_requirement":0.05},
{"date":"22/11/2015","moisture_depletion":0,"actual_et":0.01,"reference_et":0.01,"crop_coefficient":0.73,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":16.58,"applied_irrigation":0,"effective_rainfall":0.02,"irrigation_requirement":0.01},
{"date":"23/11/2015","moisture_depletion":0,"actual_et":0.02,"reference_et":0.02,"crop_coefficient":0.73,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":17.27,"applied_irrigation":0,"effective_rainfall":0.02,"irrigation_requirement":0.01},
{"date":"24/11/2015","moisture_depletion":0,"actual_et":0.03,"reference_et":0.03,"crop_coefficient":0.73,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":17.97,"applied_irrigation":0,"effective_rainfall":0.97,"irrigation_requirement":0.02},
{"date":"25/11/2015","moisture_depletion":0.03,"actual_et":0.03,"reference_et":0.04,"crop_coefficient":0.73,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":18.68,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.03},
{"date":"26/11/2015","moisture_depletion":0.03,"actual_et":0,"reference_et":0,"crop_coefficient":0.74,"crop_stress":1,"et_correction_coefficient":0.5,"root_depth":19.4,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0},
{"date":"27/11/2015","moisture_depletion":0,"actual_et":0.04,"reference_et":0.05,"crop_coefficient":0.74,"crop_stress":1,"et_correction_coefficient":0.3,"root_depth":20.13,"applied_irrigation":0,"effective_rainfall":0.23,"irrigation_requirement":0.03},
{"date":"28/11/2015","moisture_depletion":0.05,"actual_et":0.05,"reference_et":0.05,"crop_coefficient":0.74,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":20.87,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.04},
{"date":"29/11/2015","moisture_depletion":0,"actual_et":0.11,"reference_et":0.13,"crop_coefficient":0.74,"crop_stress":1,"et_correction_coefficient":0.5,"root_depth":21.63,"applied_irrigation":0,"effective_rainfall":0.66,"irrigation_requirement":0.1},
{"date":"30/11/2015","moisture_depletion":0,"actual_et":0.08,"reference_et":0.09,"crop_coefficient":0.75,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":22.39,"applied_irrigation":0,"effective_rainfall":0.42,"irrigation_requirement":0.07},
{"date":"01/12/2015","moisture_depletion":0.02,"actual_et":0.06,"reference_et":0.06,"crop_coefficient":0.75,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":23.17,"applied_irrigation":0,"effective_rainfall":0.04,"irrigation_requirement":0.05},
{"date":"02/12/2015","moisture_depletion":0.14,"actual_et":0.12,"reference_et":0.14,"crop_coefficient":0.75,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":23.96,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.11},
{"date":"03/12/2015","moisture_depletion":0.21,"actual_et":0.08,"reference_et":0.09,"crop_coefficient":0.75,"crop_stress":1,"et_correction_coefficient":0.5,"root_depth":24.75,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.07},
{"date":"04/12/2015","moisture_depletion":0.14,"actual_et":0.07,"reference_et":0.09,"crop_coefficient":0.76,"crop_stress":1,"et_correction_coefficient":0.3,"root_depth":25.56,"applied_irrigation":0,"effective_rainfall":0.15,"irrigation_requirement":0.07},
{"date":"05/12/2015","moisture_depletion":0.32,"actual_et":0.19,"reference_et":0.22,"crop_coefficient":0.76,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":26.38,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.16},
{"date":"06/12/2015","moisture_depletion":0.42,"actual_et":0.09,"reference_et":0.11,"crop_coefficient":0.76,"crop_stress":1,"et_correction_coefficient":0.5,"root_depth":27.21,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.09},
{"date":"07/12/2015","moisture_depletion":0.41,"actual_et":0.03,"reference_et":0.03,"crop_coefficient":0.76,"crop_stress":1,"et_correction_coefficient":0.3,"root_depth":28.05,"applied_irrigation":0,"effective_rainfall":0.04,"irrigation_requirement":0.03},
{"date":"08/12/2015","moisture_depletion":0.36,"actual_et":0.06,"reference_et":0.07,"crop_coefficient":0.77,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":28.9,"applied_irrigation":0,"effective_rainfall":0.1,"irrigation_requirement":0.05},
{"date":"09/12/2015","moisture_depletion":0.42,"actual_et":0.06,"reference_et":0.07,"crop_coefficient":0.77,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":29.76,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.05},
{"date":"10/12/2015","moisture_depletion":0.11,"actual_et":0.06,"reference_et":0.07,"crop_coefficient":0.77,"crop_stress":1,"et_correction_coefficient":0.5,"root_depth":30.62,"applied_irrigation":0,"effective_rainfall":0.37,"irrigation_requirement":0.06},
{"date":"11/12/2015","moisture_depletion":0.14,"actual_et":0.03,"reference_et":0.03,"crop_coefficient":0.77,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":31.5,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.02},
{"date":"12/12/2015","moisture_depletion":0,"actual_et":0.04,"reference_et":0.05,"crop_coefficient":0.78,"crop_stress":1,"et_correction_coefficient":0.5,"root_depth":32.39,"applied_irrigation":0,"effective_rainfall":0.42,"irrigation_requirement":0.04},
{"date":"13/12/2015","moisture_depletion":0,"actual_et":0,"reference_et":0,"crop_coefficient":0.78,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":33.28,"applied_irrigation":0,"effective_rainfall":0.12,"irrigation_requirement":0},
{"date":"14/12/2015","moisture_depletion":0.01,"actual_et":0.01,"reference_et":0.01,"crop_coefficient":0.78,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":34.19,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.01},
{"date":"15/12/2015","moisture_depletion":0,"actual_et":0.02,"reference_et":0.02,"crop_coefficient":0.78,"crop_stress":1,"et_correction_coefficient":0.5,"root_depth":35.1,"applied_irrigation":0,"effective_rainfall":0.55,"irrigation_requirement":0.02},
{"date":"16/12/2015","moisture_depletion":0,"actual_et":0.04,"reference_et":0.05,"crop_coefficient":0.79,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":36.02,"applied_irrigation":0,"effective_rainfall":0.06,"irrigation_requirement":0.04},
{"date":"17/12/2015","moisture_depletion":0.06,"actual_et":0.06,"reference_et":0.07,"crop_coefficient":0.79,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":36.95,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.06},
{"date":"18/12/2015","moisture_depletion":0.12,"actual_et":0.05,"reference_et":0.06,"crop_coefficient":0.79,"crop_stress":1,"et_correction_coefficient":0.5,"root_depth":37.88,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.05},
{"date":"19/12/2015","moisture_depletion":0.2,"actual_et":0.08,"reference_et":0.1,"crop_coefficient":0.79,"crop_stress":1,"et_correction_coefficient":0.3,"root_depth":38.83,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.08},
{"date":"20/12/2015","moisture_depletion":0.29,"actual_et":0.09,"reference_et":0.11,"crop_coefficient":0.8,"crop_stress":1,"et_correction_coefficient":0,"root_depth":39.78,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.09},
{"date":"21/12/2015","moisture_depletion":0.35,"actual_et":0.06,"reference_et":0.07,"crop_coefficient":0.8,"crop_stress":1,"et_correction_coefficient":0,"root_depth":40.74,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.06},
{"date":"22/12/2015","moisture_depletion":0,"actual_et":0.06,"reference_et":0.08,"crop_coefficient":0.8,"crop_stress":1,"et_correction_coefficient":0,"root_depth":41.7,"applied_irrigation":0,"effective_rainfall":0.68,"irrigation_requirement":0.06},
{"date":"23/12/2015","moisture_depletion":0.07,"actual_et":0.07,"reference_et":0.08,"crop_coefficient":0.8,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":42.68,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.06},
{"date":"24/12/2015","moisture_depletion":0,"actual_et":0.09,"reference_et":0.11,"crop_coefficient":0.81,"crop_stress":1,"et_correction_coefficient":0.5,"root_depth":43.66,"applied_irrigation":0,"effective_rainfall":0.26,"irrigation_requirement":0.09},
{"date":"25/12/2015","moisture_depletion":0.03,"actual_et":0.03,"reference_et":0.03,"crop_coefficient":0.81,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":44.64,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.03},
{"date":"26/12/2015","moisture_depletion":0.14,"actual_et":0.11,"reference_et":0.13,"crop_coefficient":0.81,"crop_stress":1,"et_correction_coefficient":0.5,"root_depth":45.64,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.11},
{"date":"27/12/2015","moisture_depletion":0,"actual_et":0.05,"reference_et":0.06,"crop_coefficient":0.81,"crop_stress":1,"et_correction_coefficient":0.3,"root_depth":46.63,"applied_irrigation":0,"effective_rainfall":0.39,"irrigation_requirement":0.05},
{"date":"28/12/2015","moisture_depletion":0.06,"actual_et":0.06,"reference_et":0.06,"crop_coefficient":0.82,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":47.64,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.05},
{"date":"29/12/2015","moisture_depletion":0.12,"actual_et":0.07,"reference_et":0.08,"crop_coefficient":0.82,"crop_stress":1,"et_correction_coefficient":0.5,"root_depth":48.65,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.06},
{"date":"30/12/2015","moisture_depletion":0.22,"actual_et":0.1,"reference_et":0.12,"crop_coefficient":0.82,"crop_stress":1,"et_correction_coefficient":0.3,"root_depth":49.67,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.09},
{"date":"31/12/2015","moisture_depletion":0.19,"actual_et":0.07,"reference_et":0.08,"crop_coefficient":0.82,"crop_stress":1,"et_correction_coefficient":0,"root_depth":50.69,"applied_irrigation":0,"effective_rainfall":0.1,"irrigation_requirement":0.07},
{"date":"01/01/2016","moisture_depletion":0.19,"actual_et":0.02,"reference_et":0.03,"crop_coefficient":0.83,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":51.71,"applied_irrigation":0,"effective_rainfall":0.02,"irrigation_requirement":0.02},
{"date":"02/01/2016","moisture_depletion":0,"actual_et":0.04,"reference_et":0.05,"crop_coefficient":0.83,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":52.74,"applied_irrigation":0,"effective_rainfall":0.41,"irrigation_requirement":0.04},
{"date":"03/01/2016","moisture_depletion":0,"actual_et":0.03,"reference_et":0.04,"crop_coefficient":0.83,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":53.78,"applied_irrigation":0,"effective_rainfall":1.07,"irrigation_requirement":0.03},
{"date":"04/01/2016","moisture_depletion":0.01,"actual_et":0.01,"reference_et":0.01,"crop_coefficient":0.83,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":54.82,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.01},
{"date":"05/01/2016","moisture_depletion":0,"actual_et":0,"reference_et":0,"crop_coefficient":0.84,"crop_stress":1,"et_correction_coefficient":0.5,"root_depth":55.86,"applied_irrigation":0,"effective_rainfall":0.04,"irrigation_requirement":0},
{"date":"06/01/2016","moisture_depletion":0.01,"actual_et":0.01,"reference_et":0.01,"crop_coefficient":0.84,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":56.91,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.01},
{"date":"07/01/2016","moisture_depletion":0,"actual_et":0.05,"reference_et":0.06,"crop_coefficient":0.84,"crop_stress":1,"et_correction_coefficient":0.5,"root_depth":57.96,"applied_irrigation":0,"effective_rainfall":1.24,"irrigation_requirement":0.05},
{"date":"08/01/2016","moisture_depletion":0.02,"actual_et":0.02,"reference_et":0.03,"crop_coefficient":0.84,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":59.02,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.02},
{"date":"09/01/2016","moisture_depletion":0,"actual_et":0.03,"reference_et":0.04,"crop_coefficient":0.85,"crop_stress":1,"et_correction_coefficient":0.5,"root_depth":60.08,"applied_irrigation":0,"effective_rainfall":0.18,"irrigation_requirement":0.03},
{"date":"10/01/2016","moisture_depletion":0,"actual_et":0.05,"reference_et":0.06,"crop_coefficient":0.85,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":61.14,"applied_irrigation":0,"effective_rainfall":0.06,"irrigation_requirement":0.05},
{"date":"11/01/2016","moisture_depletion":0,"actual_et":0.02,"reference_et":0.02,"crop_coefficient":0.85,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":62.21,"applied_irrigation":0,"effective_rainfall":1.42,"irrigation_requirement":0.02},
{"date":"12/01/2016","moisture_depletion":0,"actual_et":0.05,"reference_et":0.05,"crop_coefficient":0.85,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":63.27,"applied_irrigation":0,"effective_rainfall":0.11,"irrigation_requirement":0.05},
{"date":"13/01/2016","moisture_depletion":0.05,"actual_et":0.05,"reference_et":0.05,"crop_coefficient":0.86,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":64.34,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.04},
{"date":"14/01/2016","moisture_depletion":0,"actual_et":0.07,"reference_et":0.08,"crop_coefficient":0.86,"crop_stress":1,"et_correction_coefficient":0.5,"root_depth":65.42,"applied_irrigation":0,"effective_rainfall":0.24,"irrigation_requirement":0.07},
{"date":"15/01/2016","moisture_depletion":0.06,"actual_et":0.06,"reference_et":0.06,"crop_coefficient":0.86,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":66.49,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.05},
{"date":"16/01/2016","moisture_depletion":0.08,"actual_et":0.02,"reference_et":0.03,"crop_coefficient":0.86,"crop_stress":1,"et_correction_coefficient":0.5,"root_depth":67.57,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.02},
{"date":"17/01/2016","moisture_depletion":0.11,"actual_et":0.03,"reference_et":0.03,"crop_coefficient":0.87,"crop_stress":1,"et_correction_coefficient":0.3,"root_depth":68.64,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.03},
{"date":"18/01/2016","moisture_depletion":0.15,"actual_et":0.04,"reference_et":0.05,"crop_coefficient":0.87,"crop_stress":1,"et_correction_coefficient":0,"root_depth":69.72,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.04},
{"date":"19/01/2016","moisture_depletion":0.15,"actual_et":0,"reference_et":0,"crop_coefficient":0.87,"crop_stress":1,"et_correction_coefficient":0,"root_depth":70.8,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0},
{"date":"20/01/2016","moisture_depletion":0.15,"actual_et":0,"reference_et":0,"crop_coefficient":0.87,"crop_stress":1,"et_correction_coefficient":0,"root_depth":71.88,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0},
{"date":"21/01/2016","moisture_depletion":0.17,"actual_et":0.02,"reference_et":0.03,"crop_coefficient":0.88,"crop_stress":1,"et_correction_coefficient":0,"root_depth":72.96,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.02},
{"date":"22/01/2016","moisture_depletion":0,"actual_et":0.05,"reference_et":0.05,"crop_coefficient":0.88,"crop_stress":1,"et_correction_coefficient":0,"root_depth":74.05,"applied_irrigation":0,"effective_rainfall":0.58,"irrigation_requirement":0.05},
{"date":"23/01/2016","moisture_depletion":0,"actual_et":0.03,"reference_et":0.03,"crop_coefficient":0.88,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":75.13,"applied_irrigation":0,"effective_rainfall":0.14,"irrigation_requirement":0.03},
{"date":"24/01/2016","moisture_depletion":0.04,"actual_et":0.04,"reference_et":0.04,"crop_coefficient":0.88,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":76.21,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.04},
{"date":"25/01/2016","moisture_depletion":0.11,"actual_et":0.08,"reference_et":0.09,"crop_coefficient":0.89,"crop_stress":1,"et_correction_coefficient":0.5,"root_depth":77.29,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.08},
{"date":"26/01/2016","moisture_depletion":0.19,"actual_et":0.07,"reference_et":0.08,"crop_coefficient":0.89,"crop_stress":1,"et_correction_coefficient":0.3,"root_depth":78.37,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.07},
{"date":"27/01/2016","moisture_depletion":0.3,"actual_et":0.11,"reference_et":0.12,"crop_coefficient":0.89,"crop_stress":1,"et_correction_coefficient":0,"root_depth":79.45,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.11},
{"date":"28/01/2016","moisture_depletion":0.38,"actual_et":0.08,"reference_et":0.09,"crop_coefficient":0.89,"crop_stress":1,"et_correction_coefficient":0,"root_depth":80.53,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.08},
{"date":"29/01/2016","moisture_depletion":0.48,"actual_et":0.1,"reference_et":0.12,"crop_coefficient":0.9,"crop_stress":1,"et_correction_coefficient":0,"root_depth":81.61,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.1},
{"date":"30/01/2016","moisture_depletion":0.17,"actual_et":0.1,"reference_et":0.11,"crop_coefficient":0.9,"crop_stress":1,"et_correction_coefficient":0,"root_depth":82.69,"applied_irrigation":0,"effective_rainfall":0.4,"irrigation_requirement":0.1},
{"date":"31/01/2016","moisture_depletion":0.15,"actual_et":0.06,"reference_et":0.06,"crop_coefficient":0.9,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":83.77,"applied_irrigation":0,"effective_rainfall":0.08,"irrigation_requirement":0.06},
{"date":"01/02/2016","moisture_depletion":0.31,"actual_et":0.16,"reference_et":0.18,"crop_coefficient":0.9,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":84.84,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.16},
{"date":"02/02/2016","moisture_depletion":0.44,"actual_et":0.13,"reference_et":0.14,"crop_coefficient":0.91,"crop_stress":1,"et_correction_coefficient":0.5,"root_depth":85.91,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.13},
{"date":"03/02/2016","moisture_depletion":0.5,"actual_et":0.06,"reference_et":0.07,"crop_coefficient":0.91,"crop_stress":1,"et_correction_coefficient":0.3,"root_depth":86.98,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.06},
{"date":"04/02/2016","moisture_depletion":0.37,"actual_et":0.05,"reference_et":0.06,"crop_coefficient":0.91,"crop_stress":1,"et_correction_coefficient":0,"root_depth":88.05,"applied_irrigation":0,"effective_rainfall":0.18,"irrigation_requirement":0.05},
{"date":"05/02/2016","moisture_depletion":0.45,"actual_et":0.08,"reference_et":0.08,"crop_coefficient":0.91,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":89.11,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.08},
{"date":"06/02/2016","moisture_depletion":0.56,"actual_et":0.11,"reference_et":0.12,"crop_coefficient":0.92,"crop_stress":1,"et_correction_coefficient":0.5,"root_depth":90.17,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.11},
{"date":"07/02/2016","moisture_depletion":0.54,"actual_et":0.08,"reference_et":0.09,"crop_coefficient":0.92,"crop_stress":1,"et_correction_coefficient":0.3,"root_depth":91.23,"applied_irrigation":0,"effective_rainfall":0.1,"irrigation_requirement":0.08},
{"date":"08/02/2016","moisture_depletion":0.56,"actual_et":0.13,"reference_et":0.15,"crop_coefficient":0.92,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":92.29,"applied_irrigation":0,"effective_rainfall":0.11,"irrigation_requirement":0.13},
{"date":"09/02/2016","moisture_depletion":0.65,"actual_et":0.09,"reference_et":0.1,"crop_coefficient":0.92,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":93.34,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.09},
{"date":"10/02/2016","moisture_depletion":0.73,"actual_et":0.07,"reference_et":0.08,"crop_coefficient":0.93,"crop_stress":1,"et_correction_coefficient":0.5,"root_depth":94.38,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.07},
{"date":"11/02/2016","moisture_depletion":0.77,"actual_et":0.05,"reference_et":0.05,"crop_coefficient":0.93,"crop_stress":1,"et_correction_coefficient":0.3,"root_depth":95.43,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.05},
{"date":"12/02/2016","moisture_depletion":0.81,"actual_et":0.04,"reference_et":0.04,"crop_coefficient":0.93,"crop_stress":1,"et_correction_coefficient":0,"root_depth":96.47,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.04},
{"date":"13/02/2016","moisture_depletion":0.82,"actual_et":0.04,"reference_et":0.04,"crop_coefficient":0.93,"crop_stress":1,"et_correction_coefficient":0,"root_depth":97.5,"applied_irrigation":0,"effective_rainfall":0.02,"irrigation_requirement":0.04},
{"date":"14/02/2016","moisture_depletion":0.82,"actual_et":0.07,"reference_et":0.08,"crop_coefficient":0.94,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":98.53,"applied_irrigation":0,"effective_rainfall":0.08,"irrigation_requirement":0.07},
{"date":"15/02/2016","moisture_depletion":0.76,"actual_et":0.05,"reference_et":0.05,"crop_coefficient":0.94,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":99.56,"applied_irrigation":0,"effective_rainfall":0.1,"irrigation_requirement":0.05},
{"date":"16/02/2016","moisture_depletion":0.81,"actual_et":0.06,"reference_et":0.07,"crop_coefficient":0.94,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":100.58,"applied_irrigation":0,"effective_rainfall":0.01,"irrigation_requirement":0.06},
{"date":"17/02/2016","moisture_depletion":0.68,"actual_et":0.06,"reference_et":0.07,"crop_coefficient":0.94,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":101.59,"applied_irrigation":0,"effective_rainfall":0.19,"irrigation_requirement":0.06},
{"date":"18/02/2016","moisture_depletion":0.77,"actual_et":0.09,"reference_et":0.09,"crop_coefficient":0.95,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":102.6,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.09},
{"date":"19/02/2016","moisture_depletion":0.85,"actual_et":0.09,"reference_et":0.09,"crop_coefficient":0.95,"crop_stress":1,"et_correction_coefficient":0.5,"root_depth":103.6,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.09},
{"date":"20/02/2016","moisture_depletion":0.89,"actual_et":0.11,"reference_et":0.12,"crop_coefficient":0.95,"crop_stress":1,"et_correction_coefficient":0.3,"root_depth":104.6,"applied_irrigation":0,"effective_rainfall":0.07,"irrigation_requirement":0.11},
{"date":"21/02/2016","moisture_depletion":1,"actual_et":0.13,"reference_et":0.14,"crop_coefficient":0.95,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":105.59,"applied_irrigation":0,"effective_rainfall":0.02,"irrigation_requirement":0.13},
{"date":"22/02/2016","moisture_depletion":0.86,"actual_et":0.09,"reference_et":0.1,"crop_coefficient":0.96,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":106.58,"applied_irrigation":0,"effective_rainfall":0.24,"irrigation_requirement":0.09},
{"date":"23/02/2016","moisture_depletion":0.93,"actual_et":0.08,"reference_et":0.08,"crop_coefficient":0.96,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":107.55,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.08},
{"date":"24/02/2016","moisture_depletion":0.99,"actual_et":0.05,"reference_et":0.06,"crop_coefficient":0.96,"crop_stress":1,"et_correction_coefficient":0.5,"root_depth":108.53,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.05},
{"date":"25/02/2016","moisture_depletion":1.06,"actual_et":0.08,"reference_et":0.08,"crop_coefficient":0.96,"crop_stress":1,"et_correction_coefficient":0.3,"root_depth":109.49,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.08},
{"date":"26/02/2016","moisture_depletion":1.15,"actual_et":0.08,"reference_et":0.09,"crop_coefficient":0.97,"crop_stress":1,"et_correction_coefficient":0,"root_depth":110.45,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.08},
{"date":"27/02/2016","moisture_depletion":1.25,"actual_et":0.1,"reference_et":0.11,"crop_coefficient":0.97,"crop_stress":1,"et_correction_coefficient":0,"root_depth":111.4,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.1},
{"date":"28/02/2016","moisture_depletion":1.34,"actual_et":0.09,"reference_et":0.1,"crop_coefficient":0.97,"crop_stress":1,"et_correction_coefficient":0,"root_depth":112.34,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.09},
{"date":"29/02/2016","moisture_depletion":1.42,"actual_et":0.07,"reference_et":0.08,"crop_coefficient":0.97,"crop_stress":1,"et_correction_coefficient":0,"root_depth":113.27,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.07},
{"date":"01/03/2016","moisture_depletion":0.83,"actual_et":0.13,"reference_et":0.13,"crop_coefficient":0.98,"crop_stress":1,"et_correction_coefficient":0,"root_depth":114.2,"applied_irrigation":0,"effective_rainfall":0.72,"irrigation_requirement":0.13},
{"date":"02/03/2016","moisture_depletion":0.17,"actual_et":0.09,"reference_et":0.1,"crop_coefficient":0.98,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":115.12,"applied_irrigation":0,"effective_rainfall":0.75,"irrigation_requirement":0.09},
{"date":"03/03/2016","moisture_depletion":0.25,"actual_et":0.1,"reference_et":0.1,"crop_coefficient":0.98,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":116.03,"applied_irrigation":0,"effective_rainfall":0.02,"irrigation_requirement":0.1},
{"date":"04/03/2016","moisture_depletion":0.01,"actual_et":0.1,"reference_et":0.1,"crop_coefficient":0.98,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":116.93,"applied_irrigation":0,"effective_rainfall":0.34,"irrigation_requirement":0.1},
{"date":"05/03/2016","moisture_depletion":0,"actual_et":0.07,"reference_et":0.07,"crop_coefficient":0.99,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":117.82,"applied_irrigation":0,"effective_rainfall":0.19,"irrigation_requirement":0.07},
{"date":"06/03/2016","moisture_depletion":0,"actual_et":0.07,"reference_et":0.08,"crop_coefficient":0.99,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":118.71,"applied_irrigation":0,"effective_rainfall":0.19,"irrigation_requirement":0.07},
{"date":"07/03/2016","moisture_depletion":0.01,"actual_et":0.08,"reference_et":0.08,"crop_coefficient":0.99,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":119.58,"applied_irrigation":0,"effective_rainfall":0.07,"irrigation_requirement":0.08},
{"date":"08/03/2016","moisture_depletion":0.1,"actual_et":0.09,"reference_et":0.09,"crop_coefficient":0.99,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":120.45,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.09},
{"date":"09/03/2016","moisture_depletion":0.15,"actual_et":0.05,"reference_et":0.05,"crop_coefficient":1,"crop_stress":1,"et_correction_coefficient":0.5,"root_depth":121.3,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.05},
{"date":"10/03/2016","moisture_depletion":0.27,"actual_et":0.12,"reference_et":0.12,"crop_coefficient":1,"crop_stress":1,"et_correction_coefficient":0.3,"root_depth":122.15,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.12},
{"date":"11/03/2016","moisture_depletion":0.37,"actual_et":0.1,"reference_et":0.1,"crop_coefficient":1,"crop_stress":1,"et_correction_coefficient":0,"root_depth":122.99,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.1},
{"date":"12/03/2016","moisture_depletion":0.47,"actual_et":0.09,"reference_et":0.09,"crop_coefficient":1,"crop_stress":1,"et_correction_coefficient":0,"root_depth":123.81,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.09},
{"date":"13/03/2016","moisture_depletion":0.57,"actual_et":0.11,"reference_et":0.11,"crop_coefficient":1.01,"crop_stress":1,"et_correction_coefficient":0,"root_depth":124.63,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.11},
{"date":"14/03/2016","moisture_depletion":0.72,"actual_et":0.15,"reference_et":0.15,"crop_coefficient":1.01,"crop_stress":1,"et_correction_coefficient":0,"root_depth":125.44,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.15},
{"date":"15/03/2016","moisture_depletion":0.8,"actual_et":0.08,"reference_et":0.08,"crop_coefficient":1.01,"crop_stress":1,"et_correction_coefficient":0,"root_depth":126.23,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.08},
{"date":"16/03/2016","moisture_depletion":0.91,"actual_et":0.12,"reference_et":0.11,"crop_coefficient":1.01,"crop_stress":1,"et_correction_coefficient":0,"root_depth":127.02,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.12},
{"date":"17/03/2016","moisture_depletion":1.05,"actual_et":0.14,"reference_et":0.13,"crop_coefficient":1.02,"crop_stress":1,"et_correction_coefficient":0,"root_depth":127.79,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.14},
{"date":"18/03/2016","moisture_depletion":1.14,"actual_et":0.09,"reference_et":0.09,"crop_coefficient":1.02,"crop_stress":1,"et_correction_coefficient":0,"root_depth":128.55,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.09},
{"date":"19/03/2016","moisture_depletion":1.23,"actual_et":0.1,"reference_et":0.1,"crop_coefficient":1.02,"crop_stress":1,"et_correction_coefficient":0,"root_depth":129.31,"applied_irrigation":0,"effective_rainfall":0.01,"irrigation_requirement":0.1},
{"date":"20/03/2016","moisture_depletion":1.35,"actual_et":0.12,"reference_et":0.12,"crop_coefficient":1.02,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":130.05,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.12},
{"date":"21/03/2016","moisture_depletion":1.47,"actual_et":0.12,"reference_et":0.11,"crop_coefficient":1.03,"crop_stress":1,"et_correction_coefficient":0.5,"root_depth":130.78,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.12},
{"date":"22/03/2016","moisture_depletion":1.61,"actual_et":0.14,"reference_et":0.14,"crop_coefficient":1.03,"crop_stress":1,"et_correction_coefficient":0.3,"root_depth":131.49,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.14},
{"date":"23/03/2016","moisture_depletion":1.74,"actual_et":0.13,"reference_et":0.12,"crop_coefficient":1.03,"crop_stress":1,"et_correction_coefficient":0,"root_depth":132.2,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.13},
{"date":"24/03/2016","moisture_depletion":1.75,"actual_et":0.14,"reference_et":0.13,"crop_coefficient":1.03,"crop_stress":1,"et_correction_coefficient":0,"root_depth":132.89,"applied_irrigation":0,"effective_rainfall":0.12,"irrigation_requirement":0.14},
{"date":"25/03/2016","moisture_depletion":1.72,"actual_et":0.17,"reference_et":0.16,"crop_coefficient":1.04,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":133.58,"applied_irrigation":0,"effective_rainfall":0.2,"irrigation_requirement":0.17},
{"date":"26/03/2016","moisture_depletion":1.51,"actual_et":0.17,"reference_et":0.17,"crop_coefficient":1.04,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":134.25,"applied_irrigation":0,"effective_rainfall":0.38,"irrigation_requirement":0.17},
{"date":"27/03/2016","moisture_depletion":0.96,"actual_et":0.18,"reference_et":0.17,"crop_coefficient":1.04,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":134.9,"applied_irrigation":0,"effective_rainfall":0.73,"irrigation_requirement":0.18},
{"date":"28/03/2016","moisture_depletion":0.92,"actual_et":0.16,"reference_et":0.15,"crop_coefficient":1.04,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":135.55,"applied_irrigation":0,"effective_rainfall":0.19,"irrigation_requirement":0.16},
{"date":"29/03/2016","moisture_depletion":1.12,"actual_et":0.21,"reference_et":0.2,"crop_coefficient":1.05,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":136.18,"applied_irrigation":0,"effective_rainfall":0.01,"irrigation_requirement":0.21},
{"date":"30/03/2016","moisture_depletion":1.31,"actual_et":0.2,"reference_et":0.19,"crop_coefficient":1.05,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":136.8,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.2},
{"date":"31/03/2016","moisture_depletion":1.57,"actual_et":0.26,"reference_et":0.24,"crop_coefficient":1.05,"crop_stress":1,"et_correction_coefficient":0.5,"root_depth":137.41,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.26},
{"date":"01/04/2016","moisture_depletion":1.8,"actual_et":0.3,"reference_et":0.29,"crop_coefficient":1.05,"crop_stress":1,"et_correction_coefficient":0.3,"root_depth":138,"applied_irrigation":0,"effective_rainfall":0.07,"irrigation_requirement":0.3},
{"date":"02/04/2016","moisture_depletion":1.72,"actual_et":0.26,"reference_et":0.25,"crop_coefficient":1.06,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":138.58,"applied_irrigation":0,"effective_rainfall":0.35,"irrigation_requirement":0.26},
{"date":"03/04/2016","moisture_depletion":1.9,"actual_et":0.18,"reference_et":0.17,"crop_coefficient":1.06,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":139.15,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.18},
{"date":"04/04/2016","moisture_depletion":2.16,"actual_et":0.26,"reference_et":0.25,"crop_coefficient":1.06,"crop_stress":1,"et_correction_coefficient":0.5,"root_depth":139.7,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.26},
{"date":"05/04/2016","moisture_depletion":2.31,"actual_et":0.3,"reference_et":0.28,"crop_coefficient":1.06,"crop_stress":1,"et_correction_coefficient":0.3,"root_depth":140.24,"applied_irrigation":0,"effective_rainfall":0.16,"irrigation_requirement":0.3},
{"date":"06/04/2016","moisture_depletion":2.45,"actual_et":0.2,"reference_et":0.19,"crop_coefficient":1.07,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":140.77,"applied_irrigation":0,"effective_rainfall":0.06,"irrigation_requirement":0.2},
{"date":"07/04/2016","moisture_depletion":2.66,"actual_et":0.21,"reference_et":0.2,"crop_coefficient":1.07,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":141.28,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.21},
{"date":"08/04/2016","moisture_depletion":2.59,"actual_et":0.22,"reference_et":0.2,"crop_coefficient":1.07,"crop_stress":1,"et_correction_coefficient":0.5,"root_depth":141.78,"applied_irrigation":0,"effective_rainfall":0.28,"irrigation_requirement":0.22},
{"date":"09/04/2016","moisture_depletion":2.84,"actual_et":0.24,"reference_et":0.23,"crop_coefficient":1.07,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":142.27,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.24},
{"date":"10/04/2016","moisture_depletion":2.98,"actual_et":0.24,"reference_et":0.22,"crop_coefficient":1.08,"crop_stress":1,"et_correction_coefficient":0.5,"root_depth":142.74,"applied_irrigation":0,"effective_rainfall":0.09,"irrigation_requirement":0.24},
{"date":"11/04/2016","moisture_depletion":2.83,"actual_et":0.21,"reference_et":0.2,"crop_coefficient":1.08,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":143.2,"applied_irrigation":0,"effective_rainfall":0.36,"irrigation_requirement":0.21},
{"date":"12/04/2016","moisture_depletion":3.11,"actual_et":0.28,"reference_et":0.26,"crop_coefficient":1.08,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":143.64,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.28},
{"date":"13/04/2016","moisture_depletion":2.79,"actual_et":0.23,"reference_et":0.21,"crop_coefficient":1.08,"crop_stress":1,"et_correction_coefficient":0.5,"root_depth":144.07,"applied_irrigation":0,"effective_rainfall":0.55,"irrigation_requirement":0.23},
{"date":"14/04/2016","moisture_depletion":2.14,"actual_et":0.11,"reference_et":0.11,"crop_coefficient":1.09,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":144.48,"applied_irrigation":0,"effective_rainfall":0.76,"irrigation_requirement":0.11},
{"date":"15/04/2016","moisture_depletion":1.92,"actual_et":0.21,"reference_et":0.19,"crop_coefficient":1.09,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":144.88,"applied_irrigation":0,"effective_rainfall":0.43,"irrigation_requirement":0.21},
{"date":"16/04/2016","moisture_depletion":2.16,"actual_et":0.26,"reference_et":0.24,"crop_coefficient":1.09,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":145.27,"applied_irrigation":0,"effective_rainfall":0.01,"irrigation_requirement":0.26},
{"date":"17/04/2016","moisture_depletion":2.42,"actual_et":0.25,"reference_et":0.23,"crop_coefficient":1.09,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":145.64,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.25},
{"date":"18/04/2016","moisture_depletion":2.7,"actual_et":0.28,"reference_et":0.26,"crop_coefficient":1.1,"crop_stress":1,"et_correction_coefficient":0.5,"root_depth":146,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.28},
{"date":"19/04/2016","moisture_depletion":3,"actual_et":0.3,"reference_et":0.27,"crop_coefficient":1.1,"crop_stress":1,"et_correction_coefficient":0.3,"root_depth":146.34,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.3},
{"date":"20/04/2016","moisture_depletion":3.3,"actual_et":0.29,"reference_et":0.27,"crop_coefficient":1.1,"crop_stress":1,"et_correction_coefficient":0,"root_depth":146.66,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.29},
{"date":"21/04/2016","moisture_depletion":3.48,"actual_et":0.18,"reference_et":0.17,"crop_coefficient":1.1,"crop_stress":1,"et_correction_coefficient":0,"root_depth":146.98,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.18},
{"date":"22/04/2016","moisture_depletion":3.7,"actual_et":0.22,"reference_et":0.2,"crop_coefficient":1.11,"crop_stress":1,"et_correction_coefficient":0,"root_depth":147.27,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.22},
{"date":"23/04/2016","moisture_depletion":3.85,"actual_et":0.22,"reference_et":0.2,"crop_coefficient":1.11,"crop_stress":1,"et_correction_coefficient":0,"root_depth":147.55,"applied_irrigation":0,"effective_rainfall":0.06,"irrigation_requirement":0.22},
{"date":"24/04/2016","moisture_depletion":3.99,"actual_et":0.18,"reference_et":0.17,"crop_coefficient":1.11,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":147.82,"applied_irrigation":0,"effective_rainfall":0.04,"irrigation_requirement":0.18},
{"date":"25/04/2016","moisture_depletion":3.88,"actual_et":0.21,"reference_et":0.19,"crop_coefficient":1.11,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":148.07,"applied_irrigation":0,"effective_rainfall":0.32,"irrigation_requirement":0.21},
{"date":"26/04/2016","moisture_depletion":4.09,"actual_et":0.26,"reference_et":0.24,"crop_coefficient":1.12,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":148.31,"applied_irrigation":0,"effective_rainfall":0.05,"irrigation_requirement":0.26},
{"date":"27/04/2016","moisture_depletion":4.02,"actual_et":0.28,"reference_et":0.25,"crop_coefficient":1.12,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":148.53,"applied_irrigation":0,"effective_rainfall":0.36,"irrigation_requirement":0.28},
{"date":"28/04/2016","moisture_depletion":4.21,"actual_et":0.3,"reference_et":0.27,"crop_coefficient":1.12,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":148.73,"applied_irrigation":0,"effective_rainfall":0.1,"irrigation_requirement":0.3},
{"date":"29/04/2016","moisture_depletion":4.53,"actual_et":0.32,"reference_et":0.29,"crop_coefficient":1.12,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":148.93,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.32},
{"date":"30/04/2016","moisture_depletion":4.94,"actual_et":0.41,"reference_et":0.36,"crop_coefficient":1.13,"crop_stress":1,"et_correction_coefficient":0.5,"root_depth":149.1,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.41},
{"date":"01/05/2016","moisture_depletion":5.08,"actual_et":0.37,"reference_et":0.33,"crop_coefficient":1.13,"crop_stress":1,"et_correction_coefficient":0.3,"root_depth":149.26,"applied_irrigation":0,"effective_rainfall":0.23,"irrigation_requirement":0.37},
{"date":"02/05/2016","moisture_depletion":5.42,"actual_et":0.34,"reference_et":0.3,"crop_coefficient":1.13,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":149.4,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.34},
{"date":"03/05/2016","moisture_depletion":5.85,"actual_et":0.43,"reference_et":0.38,"crop_coefficient":1.13,"crop_stress":1,"et_correction_coefficient":0.5,"root_depth":149.53,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.43},
{"date":"04/05/2016","moisture_depletion":6.32,"actual_et":0.48,"reference_et":0.42,"crop_coefficient":1.14,"crop_stress":1,"et_correction_coefficient":0.3,"root_depth":149.64,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.48},
{"date":"05/05/2016","moisture_depletion":6.79,"actual_et":0.47,"reference_et":0.41,"crop_coefficient":1.14,"crop_stress":1,"et_correction_coefficient":0,"root_depth":149.74,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.47},
{"date":"06/05/2016","moisture_depletion":7.26,"actual_et":0.47,"reference_et":0.41,"crop_coefficient":1.14,"crop_stress":1,"et_correction_coefficient":0,"root_depth":149.82,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.47},
{"date":"07/05/2016","moisture_depletion":7.89,"actual_et":0.63,"reference_et":0.55,"crop_coefficient":1.14,"crop_stress":1,"et_correction_coefficient":0,"root_depth":149.89,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.63},
{"date":"08/05/2016","moisture_depletion":8.38,"actual_et":0.51,"reference_et":0.45,"crop_coefficient":1.15,"crop_stress":1,"et_correction_coefficient":0,"root_depth":149.94,"applied_irrigation":0,"effective_rainfall":0.02,"irrigation_requirement":0.51},
{"date":"09/05/2016","moisture_depletion":8.21,"actual_et":0.17,"reference_et":0.15,"crop_coefficient":1.15,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":149.98,"applied_irrigation":0,"effective_rainfall":0.33,"irrigation_requirement":0.17},
{"date":"01/06/2016","moisture_depletion":11.67,"actual_et":0.1,"reference_et":0.13,"crop_coefficient":0.49,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":150,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.06},
{"date":"02/06/2016","moisture_depletion":11.77,"actual_et":0.1,"reference_et":0.15,"crop_coefficient":0.46,"crop_stress":1,"et_correction_coefficient":0.5,"root_depth":150,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.07},
{"date":"03/06/2016","moisture_depletion":11.91,"actual_et":0.15,"reference_et":0.25,"crop_coefficient":0.43,"crop_stress":1,"et_correction_coefficient":0.3,"root_depth":150,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.11},
{"date":"04/06/2016","moisture_depletion":12.06,"actual_et":0.15,"reference_et":0.37,"crop_coefficient":0.4,"crop_stress":1,"et_correction_coefficient":0,"root_depth":150,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.15},
{"date":"05/06/2016","moisture_depletion":12.23,"actual_et":0.17,"reference_et":0.45,"crop_coefficient":0.37,"crop_stress":1,"et_correction_coefficient":0,"root_depth":150,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.17},
{"date":"06/06/2016","moisture_depletion":12.38,"actual_et":0.15,"reference_et":0.45,"crop_coefficient":0.34,"crop_stress":1,"et_correction_coefficient":0,"root_depth":150,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.15},
{"date":"07/06/2016","moisture_depletion":12.5,"actual_et":0.12,"reference_et":0.39,"crop_coefficient":0.31,"crop_stress":1,"et_correction_coefficient":0,"root_depth":150,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.12},
{"date":"08/06/2016","moisture_depletion":12.6,"actual_et":0.1,"reference_et":0.36,"crop_coefficient":0.28,"crop_stress":1,"et_correction_coefficient":0,"root_depth":150,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.1},
{"date":"10/05/2016","moisture_depletion":8.13,"actual_et":0.23,"reference_et":0.2,"crop_coefficient":1.15,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":150,"applied_irrigation":0,"effective_rainfall":0.32,"irrigation_requirement":0.23},
{"date":"11/05/2016","moisture_depletion":8.63,"actual_et":0.51,"reference_et":0.45,"crop_coefficient":1.12,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":150,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.51},
{"date":"12/05/2016","moisture_depletion":8.85,"actual_et":0.22,"reference_et":0.2,"crop_coefficient":1.09,"crop_stress":1,"et_correction_coefficient":0.5,"root_depth":150,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.22},
{"date":"13/05/2016","moisture_depletion":9.13,"actual_et":0.28,"reference_et":0.27,"crop_coefficient":1.06,"crop_stress":1,"et_correction_coefficient":0.3,"root_depth":150,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.28},
{"date":"14/05/2016","moisture_depletion":9.44,"actual_et":0.32,"reference_et":0.31,"crop_coefficient":1.03,"crop_stress":1,"et_correction_coefficient":0,"root_depth":150,"applied_irrigation":0,"effective_rainfall":0.01,"irrigation_requirement":0.32},
{"date":"15/05/2016","moisture_depletion":9.75,"actual_et":0.31,"reference_et":0.31,"crop_coefficient":1,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":150,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.31},
{"date":"16/05/2016","moisture_depletion":10.07,"actual_et":0.33,"reference_et":0.34,"crop_coefficient":0.97,"crop_stress":1,"et_correction_coefficient":0.5,"root_depth":150,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.33},
{"date":"17/05/2016","moisture_depletion":10.01,"actual_et":0.17,"reference_et":0.18,"crop_coefficient":0.94,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":150,"applied_irrigation":0,"effective_rainfall":0.23,"irrigation_requirement":0.17},
{"date":"18/05/2016","moisture_depletion":10.26,"actual_et":0.27,"reference_et":0.3,"crop_coefficient":0.91,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":150,"applied_irrigation":0,"effective_rainfall":0.02,"irrigation_requirement":0.27},
{"date":"19/05/2016","moisture_depletion":10.55,"actual_et":0.29,"reference_et":0.32,"crop_coefficient":0.88,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":150,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.28},
{"date":"20/05/2016","moisture_depletion":10.82,"actual_et":0.27,"reference_et":0.31,"crop_coefficient":0.85,"crop_stress":1,"et_correction_coefficient":0.5,"root_depth":150,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.26},
{"date":"21/05/2016","moisture_depletion":10.24,"actual_et":0.29,"reference_et":0.34,"crop_coefficient":0.82,"crop_stress":1,"et_correction_coefficient":0.3,"root_depth":150,"applied_irrigation":0,"effective_rainfall":0.86,"irrigation_requirement":0.28},
{"date":"22/05/2016","moisture_depletion":10.16,"actual_et":0.28,"reference_et":0.32,"crop_coefficient":0.79,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":150,"applied_irrigation":0,"effective_rainfall":0.36,"irrigation_requirement":0.25},
{"date":"23/05/2016","moisture_depletion":10.42,"actual_et":0.28,"reference_et":0.32,"crop_coefficient":0.76,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":150,"applied_irrigation":0,"effective_rainfall":0.01,"irrigation_requirement":0.24},
{"date":"24/05/2016","moisture_depletion":10.58,"actual_et":0.16,"reference_et":0.18,"crop_coefficient":0.73,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":150,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.13},
{"date":"25/05/2016","moisture_depletion":10.81,"actual_et":0.24,"reference_et":0.3,"crop_coefficient":0.7,"crop_stress":1,"et_correction_coefficient":0.5,"root_depth":150,"applied_irrigation":0,"effective_rainfall":0.01,"irrigation_requirement":0.21},
{"date":"26/05/2016","moisture_depletion":11.12,"actual_et":0.3,"reference_et":0.36,"crop_coefficient":0.67,"crop_stress":1,"et_correction_coefficient":0.8,"root_depth":150,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.24},
{"date":"27/05/2016","moisture_depletion":11.37,"actual_et":0.25,"reference_et":0.33,"crop_coefficient":0.64,"crop_stress":1,"et_correction_coefficient":0.5,"root_depth":150,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.21},
{"date":"28/05/2016","moisture_depletion":11.57,"actual_et":0.2,"reference_et":0.29,"crop_coefficient":0.61,"crop_stress":1,"et_correction_coefficient":0.3,"root_depth":150,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.18},
{"date":"29/05/2016","moisture_depletion":11.7,"actual_et":0.13,"reference_et":0.23,"crop_coefficient":0.58,"crop_stress":1,"et_correction_coefficient":0,"root_depth":150,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.13},
{"date":"30/05/2016","moisture_depletion":11.76,"actual_et":0.06,"reference_et":0.11,"crop_coefficient":0.55,"crop_stress":1,"et_correction_coefficient":0,"root_depth":150,"applied_irrigation":0,"effective_rainfall":0,"irrigation_requirement":0.06},
{"date":"31/05/2016","moisture_depletion":11.57,"actual_et":0.12,"reference_et":0.23,"crop_coefficient":0.52,"crop_stress":1,"et_correction_coefficient":0,"root_depth":150,"applied_irrigation":0,"effective_rainfall":0.31,"irrigation_requirement":0.12}]
    }

    this.getData = function () {
        return [
            {
                "title": "Oilseed Rape Sclerotinia",
                "description": "Flowering Stages of OSR",
                "slug": "e63230d4-cee0-11e5-81e8-f23c9184cad6",
                "status": 2,
                "category": ["Crop growth", "Crop development"],
                "featured_image": "/static/assets/khapps/crowdsource/csfb/images/oilseedrape.jpg",
                "stats": {
                    "growing_season": '2016/17',
                    "observation_dates": {
                        "earliest": "2016-01-29",
                        "latest": "2016-01-29",
                    },
                    "observations_recorded": {
                        "total": 100,
                        "positive": 70,
                        "negative": 10,
                        "neutral": 20
                    }
                }
            },
            {
                "title": "Wheat Yellow Rust",
                "description": "Wheat Yellow Rust Disease",
                "slug": "e63230d4-cee0-11e5-81e8-f23c9184cad6",
                "status": 2,
                "category": ["Crop growth", "Crop development"],
                "featured_image": "/static/assets/khapps/crowdsource/csfb/images/wheatyellowrust.jpg",
                "stats": {
                    "growing_season": '2016/17',
                    "observation_dates": {
                        "earliest": "2016-02-09",
                        "latest": "2016-06-07",
                    },
                    "observations_recorded": {
                        "total": 100,
                        "positive": 70,
                        "negative": 10,
                        "neutral": 20
                    }
                }
            },
            {
                "title": "Oilseed Rape Flea Beetle",
                "description": "Cabbage Stem Flea Beetle Pest Infestation",
                "slug": "e63230d4-cee0-11e5-81e8-f23c9184cad6",
                "status": 2,
                "category": ["Crop disease", "Crop pest"],
                "featured_image": "/static/assets/khapps/crowdsource/csfb/images/CSFB.jpeg",
                "stats": {
                    "growing_season": '2016/17',
                    "observation_dates": {
                        "earliest": "2016-01-29",
                        "latest": "2016-01-29",
                    },
                    "observations_recorded": {
                        "total": 100,
                        "positive": 70,
                        "negative": 10,
                        "neutral": 20
                    }
                }
            },
        ];
    };

    this.getPolygon = function () {
        return [
            {
                "type": "FeatureCollection",
                "features": [{
                    "geometry": {
                        "type": "Polygon",
                        "coordinates": [[[0.1768112182617187, 53.29974833950178], [0.1739144325256348, 53.30129998143624], [0.1758241653442383, 53.30277463019688], [0.1682925224304199, 53.307762412470076], [0.1821541786193848, 53.30968556618183], [0.1826262474060058, 53.31033941870965], [0.1829051971435547, 53.3107753148314], [0.1832485198974609, 53.3107753148314], [0.1838493347167969, 53.310570187799115], [0.184321403503418, 53.310365059781184], [0.1846218109130859, 53.30998044209098], [0.1847076416015625, 53.30953171707284], [0.1847290992736816, 53.308826568229435], [0.1844501495361328, 53.30833936767974], [0.1837635040283203, 53.3070572344034], [0.1810383796691895, 53.30194113932833], [0.1799654960632324, 53.29987657650946], [0.1794075965881348, 53.29962010210908], [0.1781415939331055, 53.29949186433127], [0.1780343055725098, 53.29987657650946], [0.1781845092773438, 53.300274108786226], [0.178377628326416, 53.300633167016905], [0.1781845092773438, 53.30079987159785], [0.1777768135070801, 53.301030692251025], [0.177454948425293, 53.30106916223859], [0.1774334907531738, 53.30085116518417], [0.1773262023925781, 53.30059469663659], [0.1770472526550293, 53.300235638082455], [0.1769614219665527, 53.29988940018905], [0.1768112182617187, 53.29974833950178]]]
                    },
                    "type": "Feature",
                    "properties": {
                        "farm_name": "Aby",
                        "soil_type": "Silty Clay Loam",
                        "field_id": 1346,
                        "farm_slug": "ian-midgley-aby",
                        "field_longitude": 0.17970874,
                        "team_id": 3,
                        "field_slug": "ae307814-d186-11e5-8759-f23c9118e215",
                        "field_area": 66.1352,
                        "field_name": "Aby WOSR 2016",
                        "field_latitude": 53.3042764,
                        "workable_area": 66.1352
                    }
                }, {
                    "geometry": {
                        "type": "Polygon",
                        "coordinates": [[[0.127866268157959, 53.29368228918074], [0.124819278717041, 53.29434921212719], [0.1238536834716797, 53.29255362662722], [0.1255059242248535, 53.29205341436798], [0.1263642311096191, 53.292489497177705], [0.127866268157959, 53.29368228918074]]]
                    },
                    "type": "Feature",
                    "properties": {
                        "farm_name": "Aby",
                        "soil_type": "Silty Clay Loam",
                        "field_id": 1345,
                        "farm_slug": "ian-midgley-aby",
                        "field_longitude": 0.12568188,
                        "team_id": 3,
                        "field_slug": "23ba0be6-d186-11e5-8759-f23c9118e215",
                        "field_area": 3.8353,
                        "field_name": "Aby WW 2016",
                        "field_latitude": 53.29302561,
                        "workable_area": 3.8353
                    }
                }, {
                    "geometry": {
                        "type": "Polygon",
                        "coordinates": [[[-0.5408191680908203, 53.96593249576211], [-0.5376863479614258, 53.96615970595411], [-0.537257194519043, 53.96441772949557], [-0.5378580093383789, 53.964165263099105], [-0.5386734008789062, 53.963786560637196], [-0.5394458770751953, 53.96340785473467], [-0.5400466918945311, 53.96300389797958], [-0.5407333374023438, 53.96479642622309], [-0.5405187606811523, 53.96489741143602], [-0.5408191680908203, 53.96593249576211]]]
                    },
                    "type": "Feature",
                    "properties": {
                        "farm_name": "Bainton",
                        "soil_type": "Silty Clay",
                        "field_id": 1350,
                        "farm_slug": "niab-niab-bainton",
                        "field_longitude": -0.53922653,
                        "team_id": 3,
                        "field_slug": "131d7266-d189-11e5-8d94-f23c9118e215",
                        "field_area": 5.41,
                        "field_name": "Bainton WB 2016",
                        "field_latitude": 53.96450748,
                        "workable_area": 5.41
                    }
                }, {
                    "geometry": {
                        "type": "Polygon",
                        "coordinates": [[[-0.542449951171875, 53.972293912958285], [-0.5427074432373047, 53.971359956172805], [-0.5427074432373047, 53.97050170715763], [-0.542449951171875, 53.96926478777761], [-0.5423641204833983, 53.968860887783975], [-0.5380725860595703, 53.96916381314618], [-0.5388021469116211, 53.972571571749754], [-0.542449951171875, 53.972293912958285]]]
                    },
                    "type": "Feature",
                    "properties": {
                        "farm_name": "Bainton",
                        "soil_type": "Silty Clay",
                        "field_id": 1349,
                        "farm_slug": "niab-niab-bainton",
                        "field_longitude": -0.54136481,
                        "team_id": 3,
                        "field_slug": "f95120e4-d188-11e5-a7a3-f23c9118e215",
                        "field_area": 10.4427,
                        "field_name": "Bainton WOSR 2016",
                        "field_latitude": 53.97057381,
                        "workable_area": 10.4427
                    }
                }, {
                    "geometry": {
                        "type": "Polygon",
                        "coordinates": [[[-0.5385875701904296, 53.972470605130574], [-0.5336952209472656, 53.97269777967973], [-0.5336523056030272, 53.971561894548756], [-0.5335235595703125, 53.96951722328583], [-0.538029670715332, 53.969214300492496], [-0.5385875701904296, 53.972470605130574]]]
                    },
                    "type": "Feature",
                    "properties": {
                        "farm_name": "Bainton",
                        "soil_type": "Silty Clay",
                        "field_id": 1348,
                        "farm_slug": "niab-niab-bainton",
                        "field_longitude": -0.53549767,
                        "team_id": 3,
                        "field_slug": "de991f40-d188-11e5-af0c-f23c9118e215",
                        "field_area": 11.073,
                        "field_name": "Bainton WW 2016",
                        "field_latitude": 53.97109236,
                        "workable_area": 11.073
                    }
                }, {
                    "geometry": {
                        "type": "Polygon",
                        "coordinates": [[[-0.5489301681518555, 53.97714005527635], [-0.5383729934692383, 53.97761959079506], [-0.5379009246826172, 53.97355598346614], [-0.5486726760864258, 53.973101642486874], [-0.5489301681518555, 53.97714005527635]]]
                    },
                    "type": "Feature",
                    "properties": {
                        "farm_name": "Bainton",
                        "soil_type": "Silt Loam",
                        "field_id": 161,
                        "farm_slug": "niab-niab-bainton",
                        "field_longitude": -0.54341555,
                        "team_id": 3,
                        "field_slug": "niab-niab-bainton-field-1",
                        "field_area": 31.6103,
                        "field_name": "Field 1",
                        "field_latitude": 53.97536062,
                        "workable_area": 31.6103
                    }
                }, {
                    "geometry": {
                        "type": "Polygon",
                        "coordinates": [[[-0.5469346046447754, 53.06947034678107], [-0.5442953109741211, 53.06892884738334], [-0.5430078506469727, 53.06879991795181], [-0.5416345596313477, 53.06861941609921], [-0.5428147315979004, 53.06600205422377], [-0.5460762977600098, 53.0661696732979], [-0.5468487739562988, 53.06623414199887], [-0.5484795570373535, 53.066504909489204], [-0.5498528480529785, 53.0667498881328], [-0.5485653877258301, 53.06758796242893], [-0.5482649803161621, 53.06783293491235], [-0.5481362342834473, 53.068181051307654], [-0.5469346046447754, 53.06947034678107]]]
                    },
                    "type": "Feature",
                    "properties": {
                        "farm_name": "Benniworth",
                        "soil_type": "Silty Clay Loam",
                        "field_id": 164,
                        "farm_slug": "niab-niab-niab-benniworth",
                        "field_longitude": -0.5457437,
                        "team_id": 3,
                        "field_slug": "niab-niab-niab-benniworth-2014-open-day",
                        "field_area": 13.4617,
                        "field_name": "2014 Open Day",
                        "field_latitude": 53.0677362,
                        "workable_area": 13.4617
                    }
                }, {
                    "geometry": {
                        "type": "Polygon",
                        "coordinates": [[[-0.2154994010925293, 53.321184217474794], [-0.2120876312255859, 53.31860786590945], [-0.2140402793884277, 53.317966958278035], [-0.2155637741088867, 53.31745422524319], [-0.2190399169921875, 53.31697994170184], [-0.2206707000732422, 53.316710751401374], [-0.2222585678100586, 53.31890268018798], [-0.2154994010925293, 53.321184217474794]]]
                    },
                    "type": "Feature",
                    "properties": {
                        "farm_name": "Benniworth",
                        "soil_type": "Silty Clay Loam",
                        "field_id": 224,
                        "farm_slug": "niab-niab-niab-benniworth",
                        "field_longitude": -0.2171731,
                        "team_id": 3,
                        "field_slug": "niab-niab-niab-benniworth-benniworth-2015",
                        "field_area": 18.5599,
                        "field_name": "Benniworth 2015",
                        "field_latitude": 53.31894748,
                        "workable_area": 18.5599
                    }
                }, {
                    "geometry": {
                        "type": "Polygon",
                        "coordinates": [[[-0.5449604988098145, 53.06602784181611], [-0.5409693717956543, 53.06580864678925], [-0.5410552024841309, 53.065473405178764], [-0.5408835411071777, 53.065473405178764], [-0.5412912368774414, 53.06303637812599], [-0.5453896522521973, 53.06324269263659], [-0.5449604988098145, 53.06602784181611]]]
                    },
                    "type": "Feature",
                    "properties": {
                        "farm_name": "Benniworth",
                        "soil_type": "Silty Clay Loam",
                        "field_id": 166,
                        "farm_slug": "niab-niab-niab-benniworth",
                        "field_longitude": -0.5431366,
                        "team_id": 3,
                        "field_slug": "niab-niab-niab-benniworth-caythorpe-a",
                        "field_area": 8.5362,
                        "field_name": "Caythorpe A",
                        "field_latitude": 53.06453211,
                        "workable_area": 8.5362
                    }
                }, {
                    "geometry": {
                        "type": "Polygon",
                        "coordinates": [[[-0.5499386787414551, 53.06671120738698], [-0.5468916893005371, 53.066130992031006], [-0.5451750755310059, 53.06602784181611], [-0.5455827713012695, 53.0632813764973], [-0.5458617210388184, 53.06326848188093], [-0.547943115234375, 53.063500584385245], [-0.5496382713317871, 53.06379715798747], [-0.5502605438232422, 53.063874524678305], [-0.5510973930358887, 53.06401636325065], [-0.552363395690918, 53.06424846172523], [-0.5533719062805176, 53.06449345320277], [-0.5499386787414551, 53.06671120738698]]]
                    },
                    "type": "Feature",
                    "properties": {
                        "farm_name": "Benniworth",
                        "soil_type": "Silty Clay Loam",
                        "field_id": 165,
                        "farm_slug": "niab-niab-niab-benniworth",
                        "field_longitude": -0.54927349,
                        "team_id": 3,
                        "field_slug": "niab-niab-niab-benniworth-open-day-2015",
                        "field_area": 13.3036,
                        "field_name": "Open Day 2015",
                        "field_latitude": 53.06498984,
                        "workable_area": 13.3036
                    }
                }, {
                    "geometry": {
                        "type": "Polygon",
                        "coordinates": [[[-2.1112632751464844, 55.69357587543122], [-2.1082162857055664, 55.69409591159041], [-2.1064138412475586, 55.69109653817133], [-2.1077656745910645, 55.69115701168255], [-2.1100401878356934, 55.6902378042179], [-2.1112632751464844, 55.69357587543122]]]
                    },
                    "type": "Feature",
                    "properties": {
                        "farm_name": "Berwick",
                        "soil_type": "Clay Loam",
                        "field_id": 1399,
                        "farm_slug": "ian-midgley-berwick",
                        "field_longitude": -2.10873985,
                        "team_id": 3,
                        "field_slug": "5f4c4e18-3562-11e6-8688-f23c9118e215",
                        "field_area": 7.6312,
                        "field_name": "2016 OSR",
                        "field_latitude": 55.69203263,
                        "workable_area": 7.6312
                    }
                }, {
                    "geometry": {
                        "type": "Polygon",
                        "coordinates": [[[-1.071016788482666, 51.18293438651749], [-1.07041597366333, 51.181172345274526], [-1.0706520080566406, 51.181172345274526], [-1.0712099075317383, 51.180190415204784], [-1.0715317726135254, 51.17922191574395], [-1.072390079498291, 51.17914120653714], [-1.0724544525146484, 51.17877801335784], [-1.0755443572998047, 51.17880491665441], [-1.0754156112670898, 51.17939678520737], [-1.074986457824707, 51.179827230291345], [-1.0749435424804688, 51.18020386644292], [-1.0744714736938477, 51.18055359725697], [-1.0738277435302734, 51.183082341113824], [-1.071016788482666, 51.18293438651749]]]
                    },
                    "type": "Feature",
                    "properties": {
                        "farm_name": "Bradley",
                        "soil_type": "Silty Clay Loam",
                        "field_id": 231,
                        "farm_slug": "ian-midgley-bradley",
                        "field_longitude": -1.07298017,
                        "team_id": 3,
                        "field_slug": "ian-midgley-bradley-herbicides-2014",
                        "field_area": 11.4183,
                        "field_name": "Herbicides 2014",
                        "field_latitude": 51.18093018,
                        "workable_area": 11.4183
                    }
                }, {
                    "geometry": {
                        "type": "Polygon",
                        "coordinates": [[[-1.0911011695861816, 51.157855948612635], [-1.0884618759155273, 51.15848845880771], [-1.087871789932251, 51.15775501533241], [-1.0874104499816895, 51.15739838264049], [-1.0869920253753662, 51.15702828919641], [-1.0882580280303955, 51.15651688246101], [-1.0894274711608887, 51.15615351107272], [-1.0904145240783691, 51.15573630335707], [-1.0908007621765137, 51.15620734405158], [-1.0908758640289307, 51.15638902989146], [-1.0908544063568115, 51.15658417314479], [-1.0907363891601562, 51.15674567038546], [-1.0908544063568115, 51.15706193417764], [-1.0911011695861816, 51.157855948612635]]]
                    },
                    "type": "Feature",
                    "properties": {
                        "farm_name": "Bradley",
                        "soil_type": "Silty Clay Loam",
                        "field_id": 211,
                        "farm_slug": "ian-midgley-bradley",
                        "field_longitude": -1.0890466,
                        "team_id": 3,
                        "field_slug": "ian-midgley-bradley-herbicides-2015",
                        "field_area": 5.0637,
                        "field_name": "Herbicides 2015",
                        "field_latitude": 51.15711238,
                        "workable_area": 5.0637
                    }
                }, {
                    "geometry": {
                        "type": "Polygon",
                        "coordinates": [[[-1.0797500610351562, 51.18726522454802], [-1.077561378479004, 51.186767602361854], [-1.0762953758239746, 51.186579311484884], [-1.0756945610046387, 51.18684829821649], [-1.0746002197265625, 51.18762835086053], [-1.0726690292358396, 51.18824700391453], [-1.0714459419250486, 51.18846218563887], [-1.0704803466796875, 51.19046601720332], [-1.0723042488098142, 51.19049291367869], [-1.0738062858581543, 51.19050636191047], [-1.0740423202514648, 51.190681188566685], [-1.0741066932678223, 51.19092325514955], [-1.076209545135498, 51.19050636191047], [-1.0766386985778809, 51.190277741436226], [-1.0774540901184082, 51.18951118215731], [-1.0788702964782715, 51.18878495634154], [-1.0795140266418457, 51.18819320832646], [-1.079878807067871, 51.18756110546294], [-1.0797500610351562, 51.18726522454802]]]
                    },
                    "type": "Feature",
                    "properties": {
                        "farm_name": "Bradley",
                        "soil_type": "Silty Clay",
                        "field_id": 1339,
                        "farm_slug": "ian-midgley-bradley",
                        "field_longitude": -1.075629,
                        "team_id": 3,
                        "field_slug": "c709406e-d17c-11e5-a7c8-f23c9118e215",
                        "field_area": 17.8888,
                        "field_name": "Red Lane",
                        "field_latitude": 51.18887235,
                        "workable_area": 17.8888
                    }
                }, {
                    "geometry": {
                        "type": "Polygon",
                        "coordinates": [[[-1.0732054710388184, 51.18544955006901], [-1.0726261138916016, 51.186229626386805], [-1.0712742805480957, 51.18726522454802], [-1.0710597038269043, 51.18766869805197], [-1.0619831085205078, 51.1902642931377], [-1.062004566192627, 51.18905393020028], [-1.0629916191101074, 51.18861012249155], [-1.0642361640930176, 51.187803188435026], [-1.0649657249450684, 51.18706348647147], [-1.0653948783874512, 51.18625652533471], [-1.0666179656982422, 51.185140205804345], [-1.067047119140625, 51.18473671016503], [-1.0671329498291016, 51.18418526041217], [-1.0677123069763184, 51.18341859979389], [-1.0688924789428709, 51.18392970828959], [-1.0698580741882322, 51.18429286088203], [-1.0708236694335938, 51.18452151104642], [-1.0718750953674316, 51.18484430934756], [-1.0732054710388184, 51.18544955006901]]]
                    },
                    "type": "Feature",
                    "properties": {
                        "farm_name": "Bradley",
                        "soil_type": "Silty Clay",
                        "field_id": 1340,
                        "farm_slug": "ian-midgley-bradley",
                        "field_longitude": -1.06776118,
                        "team_id": 3,
                        "field_slug": "ef67ce90-d17c-11e5-b513-f23c9118e215",
                        "field_area": 24.9054,
                        "field_name": "Spain Lane",
                        "field_latitude": 51.18615188,
                        "workable_area": 24.9054
                    }
                }, {
                    "geometry": {
                        "type": "Polygon",
                        "coordinates": [[[0.172462805712636, 52.0973826051931], [0.17260363954244, 52.09774922452385], [0.172715155474085, 52.09772524740233], [0.174785754514563, 52.09726172401784], [0.174823166310986, 52.097165372425984], [0.175420316138504, 52.09569443788144], [0.175915302983483, 52.094514185572955], [0.17603239471171, 52.09423340004487], [0.176124305423114, 52.09401239484443], [0.176146968338255, 52.09395758538529], [0.17616333599919, 52.09388399032014], [0.176171789626267, 52.09382232949641], [0.176174487592355, 52.093736689322064], [0.176167113151714, 52.09367513879845], [0.176159199117855, 52.09361546675554], [0.176150205897561, 52.093570602167006], [0.176096246575797, 52.09336506431268], [0.173815745773658, 52.0936665195083], [0.171998215952251, 52.09391658874986], [0.171284154260912, 52.094010626798415], [0.171302860159123, 52.09411052128856], [0.171320127142087, 52.09418301095553], [0.171346027616534, 52.094247544340426], [0.171406821785721, 52.09432434336691], [0.17151294178519, 52.094417275537275], [0.171567620564577, 52.09447031640386], [0.171632551615099, 52.09454181097215], [0.171682733784339, 52.09460689634505], [0.171721584496009, 52.094669219091905], [0.171743168224715, 52.09471518758699], [0.171756118461938, 52.09475054793558], [0.17176475195342, 52.09478679226382], [0.171780580021137, 52.09485132477533], [0.171804322122714, 52.094981273522116], [0.171835258800525, 52.095264595837996], [0.171838856088642, 52.09532470767363], [0.171855583478389, 52.095429903191096], [0.171864756563089, 52.095498854740235], [0.171874109512195, 52.095542170402496], [0.1718834624613, 52.095583939036985], [0.171896772427335, 52.09563830450267], [0.171906485105253, 52.09567145414434], [0.171930766800046, 52.09574416227216], [0.171972675206616, 52.09588548973779], [0.172011705782692, 52.09600626414448], [0.1722322195443, 52.09670339017069], [0.172301287476157, 52.09691454792528], [0.172345354255597, 52.09705996001028], [0.172407947068843, 52.097238299108696], [0.172462805712636, 52.0973826051931]]]
                    },
                    "type": "Feature",
                    "properties": {
                        "farm_name": "Cambridge",
                        "soil_type": "Loamy Sand",
                        "field_id": 1396,
                        "farm_slug": "niab-niab-niab-cambridge",
                        "field_longitude": 0.17376998,
                        "team_id": 3,
                        "field_slug": "08e76cee-33d0-11e6-aa81-f23c9118e215",
                        "field_area": 10.4222,
                        "field_name": "Big Common",
                        "field_latitude": 52.09534536,
                        "workable_area": 10.4222
                    }
                }, {
                    "geometry": {
                        "type": "Polygon",
                        "coordinates": [[[0.0990378856658936, 52.246820314136464], [0.1010334491729736, 52.24615685536616], [0.1010441780090332, 52.24609773479629], [0.1004433631896973, 52.2454999557205], [0.0982761383056641, 52.24602547621505], [0.0990378856658936, 52.246820314136464]]]
                    },
                    "type": "Feature",
                    "properties": {
                        "farm_name": "Cambridge",
                        "soil_type": "Silty Clay Loam",
                        "field_id": 196,
                        "farm_slug": "niab-niab-niab-cambridge",
                        "field_longitude": 0.09966016,
                        "team_id": 3,
                        "field_slug": "niab-niab-niab-cambridge-demo-field",
                        "field_area": 1.4671,
                        "field_name": "Demo Field",
                        "field_latitude": 52.24616013,
                        "workable_area": 1.4671
                    }
                }, {
                    "geometry": {
                        "type": "Polygon",
                        "coordinates": [[[0.0982761383056641, 52.231058845230976], [0.1004433631896973, 52.22826600465829], [0.1001644134521484, 52.2281608589933], [0.1000785827636719, 52.22812800092191], [0.1010119915008545, 52.22703709914666], [0.0996172428131104, 52.226445635171345], [0.0990486145019531, 52.227267110787054], [0.0989091396331787, 52.227464262673266], [0.0985443592071533, 52.22735254337855], [0.097353458404541, 52.22917944714445], [0.0967955589294434, 52.23009287083723], [0.0968170166015625, 52.23018486930411], [0.0982761383056641, 52.231058845230976]]]
                    },
                    "type": "Feature",
                    "properties": {
                        "farm_name": "Cambridge",
                        "soil_type": "Silty Clay Loam",
                        "field_id": 169,
                        "farm_slug": "niab-niab-niab-cambridge",
                        "field_longitude": 0.09890378,
                        "team_id": 3,
                        "field_slug": "niab-niab-niab-cambridge-field-17",
                        "field_area": 6.4466,
                        "field_name": "Field 17",
                        "field_latitude": 52.22875224,
                        "workable_area": 6.4466
                    }
                }, {
                    "geometry": {
                        "type": "Polygon",
                        "coordinates": [[[0.096055269241333, 52.229757731952816], [0.096580982208252, 52.230046871532295], [0.0966989994049072, 52.23006658552596], [0.0978577136993408, 52.22824628986506], [0.0978255271911621, 52.22818057382444], [0.0979113578796387, 52.228081999581164], [0.0985121726989746, 52.22724082380275], [0.0982332229614258, 52.22719482154275], [0.0969457626342773, 52.22841715111544], [0.097353458404541, 52.22860772634976], [0.096580982208252, 52.22927801895117], [0.096055269241333, 52.229757731952816]]]
                    },
                    "type": "Feature",
                    "properties": {
                        "farm_name": "Cambridge",
                        "soil_type": "Silty Clay Loam",
                        "field_id": 170,
                        "farm_slug": "niab-niab-niab-cambridge",
                        "field_longitude": 0.09728372,
                        "team_id": 3,
                        "field_slug": "niab-niab-niab-cambridge-field-18",
                        "field_area": 1.1646,
                        "field_name": "Field 18",
                        "field_latitude": 52.2286307,
                        "workable_area": 1.1646
                    }
                }, {
                    "geometry": {
                        "type": "Polygon",
                        "coordinates": [[[0.094531774520874, 52.23121655334016], [0.0965166091918945, 52.230217725853215], [0.094681978225708, 52.22906773216563], [0.0926971435546875, 52.2299220160358], [0.094531774520874, 52.23121655334016]]]
                    },
                    "type": "Feature",
                    "properties": {
                        "farm_name": "Cambridge",
                        "soil_type": "Silty Clay Loam",
                        "field_id": 171,
                        "farm_slug": "niab-niab-niab-cambridge",
                        "field_longitude": 0.09460688,
                        "team_id": 3,
                        "field_slug": "niab-niab-niab-cambridge-field-20",
                        "field_area": 3.1316,
                        "field_name": "Field 20",
                        "field_latitude": 52.23014214,
                        "workable_area": 3.1316
                    }
                }, {
                    "geometry": {
                        "type": "Polygon",
                        "coordinates": [[[0.0890493392944336, 52.23245191414524], [0.0900149345397949, 52.232097079986296], [0.089564323425293, 52.23153196787771], [0.0883197784423828, 52.23205765379355], [0.0890493392944336, 52.23245191414524]]]
                    },
                    "type": "Feature",
                    "properties": {
                        "farm_name": "Cambridge",
                        "soil_type": "Silty Clay Loam",
                        "field_id": 174,
                        "farm_slug": "niab-niab-niab-cambridge",
                        "field_longitude": 0.08916736,
                        "team_id": 3,
                        "field_slug": "niab-niab-niab-cambridge-field-23",
                        "field_area": 0.5995,
                        "field_name": "Field 23",
                        "field_latitude": 52.23199194,
                        "workable_area": 0.5995
                    }
                }, {
                    "geometry": {
                        "type": "Polygon",
                        "coordinates": [[[0.0946176052093506, 52.23130854947844], [0.0965273380279541, 52.23265561395498], [0.0978147983551025, 52.231052274047606], [0.0966131687164307, 52.23028343887849], [0.0946176052093506, 52.23130854947844]]]
                    },
                    "type": "Feature",
                    "properties": {
                        "farm_name": "Cambridge",
                        "soil_type": "Silty Clay Loam",
                        "field_id": 172,
                        "farm_slug": "niab-niab-niab-cambridge",
                        "field_longitude": 0.0962162,
                        "team_id": 3,
                        "field_slug": "niab-niab-niab-cambridge-field-24",
                        "field_area": 2.8698,
                        "field_name": "Field 24",
                        "field_latitude": 52.23146953,
                        "workable_area": 2.8698
                    }
                }, {
                    "geometry": {
                        "type": "Polygon",
                        "coordinates": [[[0.09613037109375, 52.2333455579787], [0.0963878631591797, 52.23280674546788], [0.0925683975219727, 52.23006001419572], [0.0899505615234375, 52.231282264886936], [0.0900578498840332, 52.23161082116193], [0.0905728340148926, 52.23211022204274], [0.0912809371948242, 52.23271475243433], [0.0919032096862793, 52.2324387721899], [0.0926327705383301, 52.23304329810726], [0.09613037109375, 52.2333455579787]]]
                    },
                    "type": "Feature",
                    "properties": {
                        "farm_name": "Cambridge",
                        "soil_type": "Silty Clay Loam",
                        "field_id": 173,
                        "farm_slug": "niab-niab-niab-cambridge",
                        "field_longitude": 0.09316921,
                        "team_id": 3,
                        "field_slug": "niab-niab-niab-cambridge-field-26",
                        "field_area": 8.4685,
                        "field_name": "Field 26",
                        "field_latitude": 52.23170279,
                        "workable_area": 8.4685
                    }
                }, {
                    "geometry": {
                        "type": "Polygon",
                        "coordinates": [[[0.0970315933227539, 52.23345069136459], [0.1009476184844971, 52.23381865625434], [0.1011514663696289, 52.23378580237035], [0.1012265682220459, 52.233713523739965], [0.1012587547302246, 52.233660957389375], [0.1013016700744629, 52.2335689661261], [0.1013338565826416, 52.23341783720826], [0.1012694835662842, 52.23332584544113], [0.1011621952056885, 52.233161573954234], [0.1010549068450928, 52.23299730185942], [0.1005828380584717, 52.23247162707089], [0.1001107692718506, 52.23212993512015], [0.0984156131744385, 52.23138740315952], [0.0980401039123535, 52.23122312449921], [0.0975573062896729, 52.23187366443111], [0.097278356552124, 52.23206422482809], [0.0971066951751709, 52.23232706541271], [0.0969457626342773, 52.232635901111], [0.0970315933227539, 52.23345069136459]]]
                    },
                    "type": "Feature",
                    "properties": {
                        "farm_name": "Cambridge",
                        "soil_type": "Silty Clay Loam",
                        "field_id": 175,
                        "farm_slug": "niab-niab-niab-cambridge",
                        "field_longitude": 0.09913981,
                        "team_id": 3,
                        "field_slug": "niab-niab-niab-cambridge-field-28",
                        "field_area": 5.4044,
                        "field_name": "Field 28",
                        "field_latitude": 52.23252089,
                        "workable_area": 5.4044
                    }
                }, {
                    "geometry": {
                        "type": "Polygon",
                        "coordinates": [[[0.1026535034179688, 52.2359672474708], [0.1029109954833984, 52.234915962010774], [0.1023638248443604, 52.23438373925318], [0.0971710681915283, 52.23389750547675], [0.0968492031097412, 52.235178785710104], [0.0969779491424561, 52.235362761373686], [0.0971710681915283, 52.235421896246486], [0.0973963737487793, 52.23550731314584], [0.0977504253387451, 52.23557958885538], [0.1026535034179688, 52.2359672474708]]]
                    },
                    "type": "Feature",
                    "properties": {
                        "farm_name": "Cambridge",
                        "soil_type": "Silty Clay Loam",
                        "field_id": 176,
                        "farm_slug": "niab-niab-niab-cambridge",
                        "field_longitude": 0.0998801,
                        "team_id": 3,
                        "field_slug": "niab-niab-niab-cambridge-field-29",
                        "field_area": 6.9185,
                        "field_name": "Field 29",
                        "field_latitude": 52.23493238,
                        "workable_area": 6.9185
                    }
                }, {
                    "geometry": {
                        "type": "Polygon",
                        "coordinates": [[[0.0968384742736816, 52.235421896246486], [0.095679759979248, 52.236276057843284], [0.0958943367004395, 52.23652573274388], [0.0968599319458008, 52.23709078128018], [0.0975894927978516, 52.2376295417898], [0.0977611541748047, 52.23770838424266], [0.0987482070922852, 52.23757698007677], [0.1016449928283691, 52.23772152463784], [0.1016449928283691, 52.23651259199464], [0.1019668579101562, 52.236249776193105], [0.102074146270752, 52.23611836770876], [0.1021385192871094, 52.23597381792662], [0.097653865814209, 52.23559272988084], [0.0968384742736816, 52.235421896246486]]]
                    },
                    "type": "Feature",
                    "properties": {
                        "farm_name": "Cambridge",
                        "soil_type": "Silty Clay Loam",
                        "field_id": 177,
                        "farm_slug": "niab-niab-niab-cambridge",
                        "field_longitude": 0.09890914,
                        "team_id": 3,
                        "field_slug": "niab-niab-niab-cambridge-field-30",
                        "field_area": 7.7697,
                        "field_name": "Field 30",
                        "field_latitude": 52.23657171,
                        "workable_area": 7.7697
                    }
                }, {
                    "geometry": {
                        "type": "Polygon",
                        "coordinates": [[[0.1036834716796875, 52.2360000997402], [0.1084363460540771, 52.2355730183412], [0.1086616516113281, 52.235073656417114], [0.1040160655975342, 52.234528294213646], [0.103297233581543, 52.23494224445075], [0.1039302349090576, 52.23544160785323], [0.1035869121551514, 52.235789844795775], [0.1036834716796875, 52.2360000997402]]]
                    },
                    "type": "Feature",
                    "properties": {
                        "farm_name": "Cambridge",
                        "soil_type": "Silty Clay Loam",
                        "field_id": 178,
                        "farm_slug": "niab-niab-niab-cambridge",
                        "field_longitude": 0.10597944,
                        "team_id": 3,
                        "field_slug": "niab-niab-niab-cambridge-field-31",
                        "field_area": 3.7359,
                        "field_name": "Field 31",
                        "field_latitude": 52.2352642,
                        "workable_area": 3.7359
                    }
                }, {
                    "geometry": {
                        "type": "Polygon",
                        "coordinates": [[[0.1021599769592285, 52.23818800614661], [0.107041597366333, 52.23765582262298], [0.1070845127105713, 52.23759012051085], [0.1064300537109375, 52.23594096563776], [0.1062905788421631, 52.23591468378916], [0.1031148433685303, 52.236184071999574], [0.1025891304016113, 52.236210353688655], [0.1020205020904541, 52.23647316972361], [0.1018595695495605, 52.23674912488547], [0.101848840713501, 52.23726160849132], [0.1021599769592285, 52.23818800614661]]]
                    },
                    "type": "Feature",
                    "properties": {
                        "farm_name": "Cambridge",
                        "soil_type": "Silty Clay Loam",
                        "field_id": 179,
                        "farm_slug": "niab-niab-niab-cambridge",
                        "field_longitude": 0.10446668,
                        "team_id": 3,
                        "field_slug": "niab-niab-niab-cambridge-field-32",
                        "field_area": 6.7795,
                        "field_name": "Field 32",
                        "field_latitude": 52.23705134,
                        "workable_area": 6.7795
                    }
                }, {
                    "geometry": {
                        "type": "Polygon",
                        "coordinates": [[[0.1021063327789307, 52.23985678717433], [0.1062905788421631, 52.239324623661155], [0.1057326793670654, 52.23786606872819], [0.1017522811889648, 52.238293128063205], [0.1021063327789307, 52.23985678717433]]]
                    },
                    "type": "Feature",
                    "properties": {
                        "farm_name": "Cambridge",
                        "soil_type": "Silty Clay Loam",
                        "field_id": 180,
                        "farm_slug": "niab-niab-niab-cambridge",
                        "field_longitude": 0.10402143,
                        "team_id": 3,
                        "field_slug": "niab-niab-niab-cambridge-field-33",
                        "field_area": 4.8472,
                        "field_name": "Field 33",
                        "field_latitude": 52.23886143,
                        "workable_area": 4.8472
                    }
                }, {
                    "geometry": {
                        "type": "Polygon",
                        "coordinates": [[[0.0994992256164551, 52.24004731330061], [0.101473331451416, 52.23936404339949], [0.1014947891235352, 52.2378923494213], [0.0999283790588379, 52.237747805416575], [0.0987911224365234, 52.23769524384359], [0.097804069519043, 52.23786606872819], [0.0994992256164551, 52.24004731330061]]]
                    },
                    "type": "Feature",
                    "properties": {
                        "farm_name": "Cambridge",
                        "soil_type": "Silty Clay Loam",
                        "field_id": 186,
                        "farm_slug": "niab-niab-niab-cambridge",
                        "field_longitude": 0.09964943,
                        "team_id": 3,
                        "field_slug": "niab-niab-niab-cambridge-field-35",
                        "field_area": 4.4146,
                        "field_name": "Field 35",
                        "field_latitude": 52.23887128,
                        "workable_area": 4.4146
                    }
                }, {
                    "geometry": {
                        "type": "Polygon",
                        "coordinates": [[[0.0951647758483887, 52.243962772544265], [0.0977182388305664, 52.24292481532409], [0.0942420959472656, 52.239429742885555], [0.0911951065063477, 52.24059917746417], [0.0951647758483887, 52.243962772544265]]]
                    },
                    "type": "Feature",
                    "properties": {
                        "farm_name": "Cambridge",
                        "soil_type": "Silty Clay Loam",
                        "field_id": 191,
                        "farm_slug": "niab-niab-niab-cambridge",
                        "field_longitude": 0.09445667,
                        "team_id": 3,
                        "field_slug": "niab-niab-niab-cambridge-field-36",
                        "field_area": 10.4046,
                        "field_name": "Field 36",
                        "field_latitude": 52.24169626,
                        "workable_area": 10.4046
                    }
                }, {
                    "geometry": {
                        "type": "Polygon",
                        "coordinates": [[[0.0902724266052246, 52.24384452547882], [0.093233585357666, 52.242451814107575], [0.0910663604736328, 52.24063859607038], [0.0904011726379395, 52.24095394365972], [0.089714527130127, 52.24144010013633], [0.0885558128356934, 52.242281006873654], [0.0902724266052246, 52.24384452547882]]]
                    },
                    "type": "Feature",
                    "properties": {
                        "farm_name": "Cambridge",
                        "soil_type": "Silty Clay Loam",
                        "field_id": 192,
                        "farm_slug": "niab-niab-niab-cambridge",
                        "field_longitude": 0.0908947,
                        "team_id": 3,
                        "field_slug": "niab-niab-niab-cambridge-field-37",
                        "field_area": 5.8606,
                        "field_name": "Field 37",
                        "field_latitude": 52.24224156,
                        "workable_area": 5.8606
                    }
                }, {
                    "geometry": {
                        "type": "Polygon",
                        "coordinates": [[[0.097804069519043, 52.242885398748626], [0.1021385192871094, 52.24120359224537], [0.1022243499755859, 52.24094080422155], [0.1009368896484375, 52.23963998058743], [0.0963020324707031, 52.24137440362638], [0.097804069519043, 52.242885398748626]]]
                    },
                    "type": "Feature",
                    "properties": {
                        "farm_name": "Cambridge",
                        "soil_type": "Silty Clay Loam",
                        "field_id": 185,
                        "farm_slug": "niab-niab-niab-cambridge",
                        "field_longitude": 0.09926319,
                        "team_id": 3,
                        "field_slug": "niab-niab-niab-cambridge-field-3839",
                        "field_area": 7.1543,
                        "field_name": "Field 38/39",
                        "field_latitude": 52.24126269,
                        "workable_area": 7.1543
                    }
                }, {
                    "geometry": {
                        "type": "Polygon",
                        "coordinates": [[[0.0919461250305176, 52.245473679532395], [0.0951218605041504, 52.24406788078239], [0.0932765007019043, 52.24251750902247], [0.090336799621582, 52.24394963399701], [0.0919461250305176, 52.245473679532395]]]
                    },
                    "type": "Feature",
                    "properties": {
                        "farm_name": "Cambridge",
                        "soil_type": "Silty Clay Loam",
                        "field_id": 193,
                        "farm_slug": "niab-niab-niab-cambridge",
                        "field_longitude": 0.09272933,
                        "team_id": 3,
                        "field_slug": "niab-niab-niab-cambridge-field-41",
                        "field_area": 5.4262,
                        "field_name": "Field 41",
                        "field_latitude": 52.24399559,
                        "workable_area": 5.4262
                    }
                }, {
                    "geometry": {
                        "type": "Polygon",
                        "coordinates": [[[0.0993704795837402, 52.24430437340781], [0.1025354862213135, 52.243470074359266], [0.1021921634674072, 52.24277371826131], [0.1020848751068115, 52.242202172543934], [0.1019775867462158, 52.241860555496835], [0.1017200946807861, 52.24145323942663], [0.0979971885681152, 52.24290510704072], [0.0979650020599365, 52.242983940121654], [0.0993704795837402, 52.24430437340781]]]
                    },
                    "type": "Feature",
                    "properties": {
                        "farm_name": "Cambridge",
                        "soil_type": "Silty Clay Loam",
                        "field_id": 184,
                        "farm_slug": "niab-niab-niab-cambridge",
                        "field_longitude": 0.10025024,
                        "team_id": 3,
                        "field_slug": "niab-niab-niab-cambridge-field-42",
                        "field_area": 5.4889,
                        "field_name": "Field 42",
                        "field_latitude": 52.24287881,
                        "workable_area": 5.4889
                    }
                }, {
                    "geometry": {
                        "type": "Polygon",
                        "coordinates": [[[0.0982332229614258, 52.24599920033816], [0.100400447845459, 52.245473679532395], [0.0978684425354004, 52.24299050953872], [0.09613037109375, 52.24367372360571], [0.0982332229614258, 52.24599920033816]]]
                    },
                    "type": "Feature",
                    "properties": {
                        "farm_name": "Cambridge",
                        "soil_type": "Silty Clay Loam",
                        "field_id": 195,
                        "farm_slug": "niab-niab-niab-cambridge",
                        "field_longitude": 0.09826541,
                        "team_id": 3,
                        "field_slug": "niab-niab-niab-cambridge-field-43",
                        "field_area": 4.6249,
                        "field_name": "Field 43",
                        "field_latitude": 52.24449485,
                        "workable_area": 4.6249
                    }
                }, {
                    "geometry": {
                        "type": "Polygon",
                        "coordinates": [[[0.0934910774230957, 52.247050223276865], [0.0965166091918945, 52.24615685536616], [0.0963449478149414, 52.24606489000125], [0.096430778503418, 52.245894096674945], [0.0951862335205078, 52.244094157803005], [0.092010498046875, 52.24552623189307], [0.0934910774230957, 52.247050223276865]]]
                    },
                    "type": "Feature",
                    "properties": {
                        "farm_name": "Cambridge",
                        "soil_type": "Silty Clay Loam",
                        "field_id": 194,
                        "farm_slug": "niab-niab-niab-cambridge",
                        "field_longitude": 0.09426355,
                        "team_id": 3,
                        "field_slug": "niab-niab-niab-cambridge-field-44",
                        "field_area": 5.5102,
                        "field_name": "Field 44",
                        "field_latitude": 52.24557219,
                        "workable_area": 5.5102
                    }
                }, {
                    "geometry": {
                        "type": "Polygon",
                        "coordinates": [[[0.101172924041748, 52.2460714589622], [0.1022565364837646, 52.24499413636591], [0.1010441780090332, 52.24392992616879], [0.0993919372558594, 52.2443569271534], [0.101172924041748, 52.2460714589622]]]
                    },
                    "type": "Feature",
                    "properties": {
                        "farm_name": "Cambridge",
                        "soil_type": "Silty Clay Loam",
                        "field_id": 183,
                        "farm_slug": "niab-niab-niab-cambridge",
                        "field_longitude": 0.10082424,
                        "team_id": 3,
                        "field_slug": "niab-niab-niab-cambridge-field-45",
                        "field_area": 2.2962,
                        "field_name": "Field 45",
                        "field_latitude": 52.24500069,
                        "workable_area": 2.2962
                    }
                }, {
                    "geometry": {
                        "type": "Polygon",
                        "coordinates": [[[0.1033401489257812, 52.2461634243135], [0.1045739650726318, 52.245355436493305], [0.1044237613677979, 52.245112380367814], [0.1040804386138916, 52.244875892048896], [0.1037907600402832, 52.24470509414578], [0.1033616065979004, 52.24421897343847], [0.1022458076477051, 52.24525033130513], [0.1033401489257812, 52.2461634243135]]]
                    },
                    "type": "Feature",
                    "properties": {
                        "farm_name": "Cambridge",
                        "soil_type": "Silty Clay Loam",
                        "field_id": 182,
                        "farm_slug": "niab-niab-niab-cambridge",
                        "field_longitude": 0.10340989,
                        "team_id": 3,
                        "field_slug": "niab-niab-niab-cambridge-field-47",
                        "field_area": 1.7186,
                        "field_name": "Field 47",
                        "field_latitude": 52.2451912,
                        "workable_area": 1.7186
                    }
                }, {
                    "geometry": {
                        "type": "Polygon",
                        "coordinates": [[[0.1032543182373047, 52.24373284740539], [0.1054751873016357, 52.243332117887135], [0.1053249835968018, 52.24293138474991], [0.1057112216949463, 52.24283284326017], [0.1054322719573975, 52.24170288520347], [0.1047348976135254, 52.241709454810234], [0.1035547256469727, 52.24180799879463], [0.1022779941558838, 52.24196566871451], [0.1023960113525391, 52.242747440458736], [0.1027393341064453, 52.24339781149879], [0.1032543182373047, 52.24373284740539]]]
                    },
                    "type": "Feature",
                    "properties": {
                        "farm_name": "Cambridge",
                        "soil_type": "Silty Clay Loam",
                        "field_id": 181,
                        "farm_slug": "niab-niab-niab-cambridge",
                        "field_longitude": 0.10399461,
                        "team_id": 3,
                        "field_slug": "niab-niab-niab-cambridge-field-49",
                        "field_area": 4.0595,
                        "field_name": "Field 49",
                        "field_latitude": 52.24271787,
                        "workable_area": 4.0595
                    }
                }, {
                    "geometry": {
                        "type": "Polygon",
                        "coordinates": [[[0.0962376594543457, 52.24116417414102], [0.0992202758789062, 52.24006045300329], [0.0975465774536133, 52.23801061234779], [0.0944352149963379, 52.23933776357783], [0.0962376594543457, 52.24116417414102]]]
                    },
                    "type": "Feature",
                    "properties": {
                        "farm_name": "Cambridge",
                        "soil_type": "Silty Clay Loam",
                        "field_id": 187,
                        "farm_slug": "niab-niab-niab-cambridge",
                        "field_longitude": 0.09682775,
                        "team_id": 3,
                        "field_slug": "niab-niab-niab-cambridge-field-51",
                        "field_area": 6.0843,
                        "field_name": "Field 51",
                        "field_latitude": 52.23958739,
                        "workable_area": 6.0843
                    }
                }, {
                    "geometry": {
                        "type": "Polygon",
                        "coordinates": [[[0.0931048393249512, 52.239679400045645], [0.0940918922424316, 52.23929834381616], [0.0943493843078613, 52.239311483740615], [0.0974607467651367, 52.23799747203818], [0.0971817970275879, 52.23759012051085], [0.0966453552246094, 52.23723532742471], [0.0955724716186523, 52.23659143643165], [0.091710090637207, 52.238181436018564], [0.0931048393249512, 52.239679400045645]]]
                    },
                    "type": "Feature",
                    "properties": {
                        "farm_name": "Cambridge",
                        "soil_type": "Silty Clay Loam",
                        "field_id": 188,
                        "farm_slug": "niab-niab-niab-cambridge",
                        "field_longitude": 0.09458542,
                        "team_id": 3,
                        "field_slug": "niab-niab-niab-cambridge-field-52",
                        "field_area": 6.866,
                        "field_name": "Field 52",
                        "field_latitude": 52.23813542,
                        "workable_area": 6.866
                    }
                }, {
                    "geometry": {
                        "type": "Polygon",
                        "coordinates": [[[0.0916242599487305, 52.23795805108602], [0.0953793525695801, 52.236460028958824], [0.095207691192627, 52.236249776193105], [0.0951647758483887, 52.23606580420609], [0.0937485694885254, 52.23469913128726], [0.0926756858825684, 52.23434431509133], [0.0920963287353516, 52.23464656610388], [0.0896930694580078, 52.23561901192007], [0.0890493392944336, 52.235921254252766], [0.086967945098877, 52.23636804349637], [0.0871181488037109, 52.23664399931185], [0.0868391990661621, 52.23669656212978], [0.0874829292297363, 52.23769524384359], [0.0903797149658203, 52.23697251590271], [0.0916242599487305, 52.23795805108602]]]
                    },
                    "type": "Feature",
                    "properties": {
                        "farm_name": "Cambridge",
                        "soil_type": "Silty Clay Loam",
                        "field_id": 189,
                        "farm_slug": "niab-niab-niab-cambridge",
                        "field_longitude": 0.09110928,
                        "team_id": 3,
                        "field_slug": "niab-niab-niab-cambridge-field-5354",
                        "field_area": 12.2047,
                        "field_name": "Field 53/54",
                        "field_latitude": 52.23615118,
                        "workable_area": 12.2047
                    }
                }, {
                    "geometry": {
                        "type": "Polygon",
                        "coordinates": [[[0.0910663604736328, 52.24044150268913], [0.0929117202758789, 52.23975823885703], [0.0915813446044922, 52.238247137255335], [0.0901222229003906, 52.237182765244796], [0.0885558128356934, 52.23757698007677], [0.0910663604736328, 52.24044150268913]]]
                    },
                    "type": "Feature",
                    "properties": {
                        "farm_name": "Cambridge",
                        "soil_type": "Silty Clay Loam",
                        "field_id": 190,
                        "farm_slug": "niab-niab-niab-cambridge",
                        "field_longitude": 0.09073377,
                        "team_id": 3,
                        "field_slug": "niab-niab-niab-cambridge-field-56",
                        "field_area": 4.9038,
                        "field_name": "Field 56",
                        "field_latitude": 52.23881213,
                        "workable_area": 4.9038
                    }
                }, {
                    "geometry": {
                        "type": "Polygon",
                        "coordinates": [[[0.0290107727050781, 52.26450669975957], [0.0299334526062012, 52.26416525444505], [0.0281739234924316, 52.26199832865925], [0.0271010398864746, 52.26237918995247], [0.0290107727050781, 52.26450669975957]]]
                    },
                    "type": "Feature",
                    "properties": {
                        "farm_name": "Cambridge",
                        "soil_type": "Silty Clay Loam",
                        "field_id": 202,
                        "farm_slug": "niab-niab-niab-cambridge",
                        "field_longitude": 0.02851725,
                        "team_id": 3,
                        "field_slug": "niab-niab-niab-cambridge-field-60",
                        "field_area": 2.1274,
                        "field_name": "Field 60",
                        "field_latitude": 52.26325251,
                        "workable_area": 2.1274
                    }
                }, {
                    "geometry": {
                        "type": "Polygon",
                        "coordinates": [[[0.026242733001709, 52.26547849126353], [0.0287318229675293, 52.26457236201864], [0.0267791748046875, 52.262431722287936], [0.0240540504455566, 52.26360055065474], [0.026242733001709, 52.26547849126353]]]
                    },
                    "type": "Feature",
                    "properties": {
                        "farm_name": "Cambridge",
                        "soil_type": "Silty Clay Loam",
                        "field_id": 203,
                        "farm_slug": "niab-niab-niab-cambridge",
                        "field_longitude": 0.02639294,
                        "team_id": 3,
                        "field_slug": "niab-niab-niab-cambridge-field-61",
                        "field_area": 5.6022,
                        "field_name": "Field 61",
                        "field_latitude": 52.26395511,
                        "workable_area": 5.6022
                    }
                }, {
                    "geometry": {
                        "type": "Polygon",
                        "coordinates": [[[0.0216078758239746, 52.26462489175585], [0.0239682197570801, 52.263626816106786], [0.0261998176574707, 52.265491623435295], [0.023646354675293, 52.266437129580744], [0.0216078758239746, 52.26462489175585]]]
                    },
                    "type": "Feature",
                    "properties": {
                        "farm_name": "Cambridge",
                        "soil_type": "Silty Clay Loam",
                        "field_id": 204,
                        "farm_slug": "niab-niab-niab-cambridge",
                        "field_longitude": 0.02390385,
                        "team_id": 3,
                        "field_slug": "niab-niab-niab-cambridge-field-62",
                        "field_area": 4.9993,
                        "field_name": "Field 62",
                        "field_latitude": 52.26503197,
                        "workable_area": 4.9993
                    }
                }, {
                    "geometry": {
                        "type": "Polygon",
                        "coordinates": [[[0.0209641456604004, 52.267382615563236], [0.0235390663146973, 52.26646339335252], [0.0215649604797363, 52.264651156601126], [0.0198054313659668, 52.26532090489897], [0.0199341773986816, 52.26553101992724], [0.0202775001525879, 52.26585932266556], [0.0194835662841797, 52.26650278898103], [0.0209641456604004, 52.267382615563236]]]
                    },
                    "type": "Feature",
                    "properties": {
                        "farm_name": "Cambridge",
                        "soil_type": "Silty Clay Loam",
                        "field_id": 205,
                        "farm_slug": "niab-niab-niab-cambridge",
                        "field_longitude": 0.02151132,
                        "team_id": 3,
                        "field_slug": "niab-niab-niab-cambridge-field-63",
                        "field_area": 4.6324,
                        "field_name": "Field 63",
                        "field_latitude": 52.26601689,
                        "workable_area": 4.6324
                    }
                }, {
                    "geometry": {
                        "type": "Polygon",
                        "coordinates": [[[0.0197839736938477, 52.26526837598632], [0.0230884552001953, 52.26394200031777], [0.0207281112670898, 52.26189326289924], [0.0172734260559082, 52.26336416088622], [0.0176382064819336, 52.26395513294461], [0.0196337699890137, 52.26490067185527], [0.0197839736938477, 52.26526837598632]]]
                    },
                    "type": "Feature",
                    "properties": {
                        "farm_name": "Cambridge",
                        "soil_type": "Silty Clay Loam",
                        "field_id": 206,
                        "farm_slug": "niab-niab-niab-cambridge",
                        "field_longitude": 0.02018094,
                        "team_id": 3,
                        "field_slug": "niab-niab-niab-cambridge-field-64",
                        "field_area": 7.7243,
                        "field_name": "Field 64",
                        "field_latitude": 52.26358082,
                        "workable_area": 7.7243
                    }
                }, {
                    "geometry": {
                        "type": "Polygon",
                        "coordinates": [[[0.0246173143386841, 52.26175536371144], [0.025743842124939, 52.26126942982221], [0.0262320041656494, 52.26168313063242], [0.026516318321228, 52.26201474516176], [0.0267791748046875, 52.26234964048642], [0.0260013341903687, 52.262674683529895], [0.0256097316741943, 52.26234964048642], [0.0248908996582031, 52.26264513426076], [0.0247889757156372, 52.2626943830317], [0.0250840187072754, 52.263016140322506], [0.0239682197570801, 52.26351847101684], [0.0232011079788208, 52.26385992131193], [0.0231099128723145, 52.26385663814851], [0.0219941139221191, 52.26287824462663], [0.0246173143386841, 52.26175536371144]]]
                    },
                    "type": "Feature",
                    "properties": {
                        "farm_name": "Cambridge",
                        "soil_type": "Silty Clay Loam",
                        "field_id": 201,
                        "farm_slug": "niab-niab-niab-cambridge",
                        "field_longitude": 0.02438664,
                        "team_id": 3,
                        "field_slug": "niab-niab-niab-cambridge-field-65",
                        "field_area": 3.9033,
                        "field_name": "Field 65",
                        "field_latitude": 52.26256468,
                        "workable_area": 3.9033
                    }
                }]
            }, 3, 119
        ]
    };

    this.getPoint = function () {
        return [
            {
                "type": "FeatureCollection",
                "features": [{
                    "geometry": {"type": "Point", "coordinates": [0.13309658, 53.29641885]},
                    "type": "Feature",
                    "properties": {
                        "team_id": 3,
                        "farm_location": "Alford",
                        "farm_slug": "ian-midgley-aby",
                        "farm_name": "Aby"
                    }
                }, {
                    "geometry": {"type": "Point", "coordinates": [-0.54605484, 53.96643741]},
                    "type": "Feature",
                    "properties": {
                        "team_id": 3,
                        "farm_location": "Driffield",
                        "farm_slug": "niab-niab-bainton",
                        "farm_name": "Bainton"
                    }
                }, {
                    "geometry": {"type": "Point", "coordinates": [-0.21196693, 53.31588074]},
                    "type": "Feature",
                    "properties": {
                        "team_id": 3,
                        "farm_location": "Market Rasen",
                        "farm_slug": "niab-niab-niab-benniworth",
                        "farm_name": "Benniworth"
                    }
                }, {
                    "geometry": {"type": "Point", "coordinates": [-2.01407075, 55.66942891]},
                    "type": "Feature",
                    "properties": {
                        "team_id": 3,
                        "farm_location": "Berwick-upon-Tweed",
                        "farm_slug": "ian-midgley-berwick",
                        "farm_name": "Berwick"
                    }
                }, {
                    "geometry": {"type": "Point", "coordinates": [-1.093809, 51.170064]},
                    "type": "Feature",
                    "properties": {
                        "team_id": 3,
                        "farm_location": "Bradley, Hampshire",
                        "farm_slug": "ian-midgley-bradley",
                        "farm_name": "Bradley"
                    }
                }, {
                    "geometry": {"type": "Point", "coordinates": [-1.5944016, 51.11693296]},
                    "type": "Feature",
                    "properties": {
                        "team_id": 3,
                        "farm_location": "Stockbridge",
                        "farm_slug": "ian-midgley-broughton",
                        "farm_name": "Broughton"
                    }
                }, {
                    "geometry": {"type": "Point", "coordinates": [0.09614915, 52.22193875]},
                    "type": "Feature",
                    "properties": {
                        "team_id": 3,
                        "farm_location": "Cambridge",
                        "farm_slug": "niab-niab-niab-cambridge",
                        "farm_name": "Cambridge"
                    }
                }, {
                    "geometry": {"type": "Point", "coordinates": [-0.6045819, 53.021631]},
                    "type": "Feature",
                    "properties": {
                        "team_id": 3,
                        "farm_location": "Caythorpe, Lincolnshire",
                        "farm_slug": "ian-midgley-caythorpe",
                        "farm_name": "Caythorpe"
                    }
                }, {
                    "geometry": {"type": "Point", "coordinates": [-0.01787424, 52.2381683]},
                    "type": "Feature",
                    "properties": {
                        "team_id": 3,
                        "farm_location": "Cambridge",
                        "farm_slug": "ian-midgley-childerley",
                        "farm_name": "Childerley"
                    }
                }, {
                    "geometry": {"type": "Point", "coordinates": [-2.00811625, 51.69784484]},
                    "type": "Feature",
                    "properties": {
                        "team_id": 3,
                        "farm_location": "Cirencester",
                        "farm_slug": "niab-niab-cirencester",
                        "farm_name": "Cirencester"
                    }
                }, {
                    "geometry": {"type": "Point", "coordinates": [0.56123078, 52.07815759]},
                    "type": "Feature",
                    "properties": {
                        "team_id": 3,
                        "farm_location": "Sudbury",
                        "farm_slug": "ian-midgley-clare",
                        "farm_name": "Clare"
                    }
                }, {
                    "geometry": {"type": "Point", "coordinates": [-0.66935062, 54.18033271]},
                    "type": "Feature",
                    "properties": {
                        "team_id": 3,
                        "farm_location": "Malton",
                        "farm_slug": "5fa3980a-053b-11e6-b880-f23c9118e215",
                        "farm_name": "Cockerills"
                    }
                }, {
                    "geometry": {"type": "Point", "coordinates": [0.74837923, 51.89631748]},
                    "type": "Feature",
                    "properties": {
                        "team_id": 3,
                        "farm_location": "Colchester",
                        "farm_slug": "ian-midgley-colchester",
                        "farm_name": "Colchester"
                    }
                }, {
                    "geometry": {"type": "Point", "coordinates": [-1.57620549, 54.4821501]},
                    "type": "Feature",
                    "properties": {
                        "team_id": 3,
                        "farm_location": "Darlington",
                        "farm_slug": "ian-midgley-croft",
                        "farm_name": "Croft"
                    }
                }, {
                    "geometry": {"type": "Point", "coordinates": [-2.10162878, 55.67723354]},
                    "type": "Feature",
                    "properties": {
                        "team_id": 3,
                        "farm_location": "Berwick-upon-Tweed",
                        "farm_slug": "0f1705f2-d18d-11e5-9c1c-f23c9118e215",
                        "farm_name": "Duddo"
                    }
                }, {
                    "geometry": {"type": "Point", "coordinates": [-0.443377, 54.005996]},
                    "type": "Feature",
                    "properties": {
                        "team_id": 3,
                        "farm_location": "Driffield",
                        "farm_slug": "ian-midgley-elmswell",
                        "farm_name": "Elmswell"
                    }
                }, {
                    "geometry": {"type": "Point", "coordinates": [-2.33596802, 51.76868974]},
                    "type": "Feature",
                    "properties": {
                        "team_id": 3,
                        "farm_location": "Whitminster",
                        "farm_slug": "023c6432-fa53-11e5-9458-f23c9118e215",
                        "farm_name": "Fromebridge"
                    }
                }, {
                    "geometry": {"type": "Point", "coordinates": [-2.33479857, 51.76296953]},
                    "type": "Feature",
                    "properties": {
                        "team_id": 3,
                        "farm_location": "Gloucester",
                        "farm_slug": "f5232170-fd6b-11e5-98fd-f23c9118e215",
                        "farm_name": "Fromebridge Mill"
                    }
                }, {
                    "geometry": {"type": "Point", "coordinates": [-2.42516756, 52.77585793]},
                    "type": "Feature",
                    "properties": {
                        "team_id": 3,
                        "farm_location": "Newport",
                        "farm_slug": "niab-niab-niab-harper-adams",
                        "farm_name": "Harper Adams"
                    }
                }, {
                    "geometry": {"type": "Point", "coordinates": [-1.32221639, 53.86623679]},
                    "type": "Feature",
                    "properties": {
                        "team_id": 3,
                        "farm_location": "Tadcaster",
                        "farm_slug": "niab-niab-niab-headley-hall",
                        "farm_name": "Headley Hall"
                    }
                }, {
                    "geometry": {"type": "Point", "coordinates": [-2.75206447, 51.99865479]},
                    "type": "Feature",
                    "properties": {
                        "team_id": 3,
                        "farm_location": "Hereford",
                        "farm_slug": "niab-niab-niab-hereford",
                        "farm_name": "Hereford"
                    }
                }, {
                    "geometry": {"type": "Point", "coordinates": [0.17912865, 52.08893385]},
                    "type": "Feature",
                    "properties": {
                        "team_id": 3,
                        "farm_location": "Hinxton",
                        "farm_slug": "fdcdf4c6-0c66-11e6-84c4-f23c9118e215",
                        "farm_name": "Hinxton"
                    }
                }, {
                    "geometry": {"type": "Point", "coordinates": [1.03228569, 52.55385685]},
                    "type": "Feature",
                    "properties": {
                        "team_id": 3,
                        "farm_location": "Wymondham",
                        "farm_slug": "niab-niab-niab-morley",
                        "farm_name": "Morley"
                    }
                }, {
                    "geometry": {"type": "Point", "coordinates": [-3.6568433, 50.57630795]},
                    "type": "Feature",
                    "properties": {
                        "team_id": 3,
                        "farm_location": "Newton Abbot",
                        "farm_slug": "niab-niab-niab-newton-abbot",
                        "farm_name": "Newton Abbot"
                    }
                }, {
                    "geometry": {"type": "Point", "coordinates": [0.88548169, 51.81061389]},
                    "type": "Feature",
                    "properties": {
                        "team_id": 3,
                        "farm_location": "Colchester",
                        "farm_slug": "ian-midgley-peldon",
                        "farm_name": "Peldon"
                    }
                }, {
                    "geometry": {"type": "Point", "coordinates": [-2.09555626, 55.71202688]},
                    "type": "Feature",
                    "properties": {
                        "team_id": 3,
                        "farm_location": "Berwick-upon-Tweed",
                        "farm_slug": "e43dd91e-d18c-11e5-8759-f23c9118e215",
                        "farm_name": "Shoreswood"
                    }
                }, {
                    "geometry": {"type": "Point", "coordinates": [-0.382119, 52.250448]},
                    "type": "Feature",
                    "properties": {
                        "team_id": 3,
                        "farm_location": "Little Staughton",
                        "farm_slug": "ian-midgley-staughton",
                        "farm_name": "Staughton"
                    }
                }, {
                    "geometry": {"type": "Point", "coordinates": [1.10004902, 52.20096578]},
                    "type": "Feature",
                    "properties": {
                        "team_id": 3,
                        "farm_location": "Stowmarket",
                        "farm_slug": "ian-midgley-stonham",
                        "farm_name": "Stonham"
                    }
                }, {
                    "geometry": {"type": "Point", "coordinates": [-1.3869381, 54.85393405]},
                    "type": "Feature",
                    "properties": {
                        "team_id": 3,
                        "farm_location": "Sunderland",
                        "farm_slug": "e50c3492-d18e-11e5-b633-f23c9118e215",
                        "farm_name": "Sunderland"
                    }
                }, {
                    "geometry": {"type": "Point", "coordinates": [-1.33028448, 51.16818362]},
                    "type": "Feature",
                    "properties": {
                        "team_id": 3,
                        "farm_location": "Winchester",
                        "farm_slug": "niab-niab-sutton-scotney",
                        "farm_name": "Sutton Scotney"
                    }
                }, {
                    "geometry": {"type": "Point", "coordinates": [-3.106849, 51.015344]},
                    "type": "Feature",
                    "properties": {
                        "team_id": 3,
                        "farm_location": "Taunton",
                        "farm_slug": "ian-midgley-taunton",
                        "farm_name": "Taunton"
                    }
                }, {
                    "geometry": {"type": "Point", "coordinates": [-1.64625406, 52.30468694]},
                    "type": "Feature",
                    "properties": {
                        "team_id": 3,
                        "farm_location": "Warwick",
                        "farm_slug": "niab-niab-warwick",
                        "farm_name": "Warwick"
                    }
                }, {
                    "geometry": {"type": "Point", "coordinates": [0.01517057, 53.73919968]},
                    "type": "Feature",
                    "properties": {
                        "team_id": 3,
                        "farm_location": "Withernsea",
                        "farm_slug": "57bbeec6-d188-11e5-a7a3-f23c9118e215",
                        "farm_name": "Withernsea"
                    }
                }, {
                    "geometry": {"type": "Point", "coordinates": [-0.30577183, 53.27749339]},
                    "type": "Feature",
                    "properties": {
                        "team_id": 3,
                        "farm_location": "Market Rasen",
                        "farm_slug": "ian-midgley-wragby",
                        "farm_name": "Wragby"
                    }
                }, {
                    "geometry": {"type": "Point", "coordinates": [0.99817067, 51.13774568]},
                    "type": "Feature",
                    "properties": {
                        "team_id": 3,
                        "farm_location": "Ashford",
                        "farm_slug": "niab-niab-niab-wye",
                        "farm_name": "Wye"
                    }
                }]
            }, 1, 35
        ]
    };

    this.getPolyline = function () {
        return [
            {
                "type": "FeatureCollection",
                "features": [{
                    "geometry": {
                        "type": "LineString",
                        "coordinates": [[-0.5389739636320617, 53.97255849362945], [-0.5382763129007108, 53.96914943273558]]
                    },
                    "type": "Feature",
                    "properties": {
                        "field_tramline_slug": "af82b1f9-369f-445e-8dd6-0b88d2b83e00",
                        "field_slug": "f95120e4-d188-11e5-a7a3-f23c9118e215",
                        "name": "Bainton WOSR 2016_0",
                        "field_name": "Bainton WOSR 2016",
                        "field_id": 1349,
                        "type": "MAIN_TRAMLINE",
                        "length": 1176.78
                    }
                }, {
                    "geometry": {
                        "type": "LineString",
                        "coordinates": [[-0.5388832526026246, 53.9725653982529], [-0.5381855078834893, 53.969155842364394]]
                    },
                    "type": "Feature",
                    "properties": {
                        "field_tramline_slug": "043b5ab2-cf71-4cfe-939c-63ab448cd61e",
                        "field_slug": "f95120e4-d188-11e5-a7a3-f23c9118e215",
                        "name": "Bainton WOSR 2016_1",
                        "field_name": "Bainton WOSR 2016",
                        "field_id": 1349,
                        "type": "TERTIARY_TRAMLINE",
                        "length": 1176.0
                    }
                }, {
                    "geometry": {
                        "type": "LineString",
                        "coordinates": [[-0.5385810705885752, 53.97153893034666], [-0.5380947030984234, 53.96916225197683]]
                    },
                    "type": "Feature",
                    "properties": {
                        "field_tramline_slug": "e422b2bc-f832-4113-904b-7cae005a09de",
                        "field_slug": "f95120e4-d188-11e5-a7a3-f23c9118e215",
                        "name": "Bainton WOSR 2016_2",
                        "field_name": "Bainton WOSR 2016",
                        "field_id": 1349,
                        "type": "SECONDARY_TRAMLINE",
                        "length": 1176.0
                    }
                }, {
                    "geometry": {
                        "type": "LineString",
                        "coordinates": [[-0.5390646743788938, 53.972551589027525], [-0.5383671174165511, 53.969143023142145]]
                    },
                    "type": "Feature",
                    "properties": {
                        "field_tramline_slug": "ccc6ec44-152c-4e96-bca7-b084402cf5db",
                        "field_slug": "f95120e4-d188-11e5-a7a3-f23c9118e215",
                        "name": "Bainton WOSR 2016_3",
                        "field_name": "Bainton WOSR 2016",
                        "field_id": 1349,
                        "type": "TERTIARY_TRAMLINE",
                        "length": 1176.0
                    }
                }, {
                    "geometry": {
                        "type": "LineString",
                        "coordinates": [[-0.5391553852453234, 53.97254468441649], [-0.5384579221645451, 53.96913661353233]]
                    },
                    "type": "Feature",
                    "properties": {
                        "field_tramline_slug": "737a2fef-0f93-44a8-bbd4-1ac9e739012d",
                        "field_slug": "f95120e4-d188-11e5-a7a3-f23c9118e215",
                        "name": "Bainton WOSR 2016_4",
                        "field_name": "Bainton WOSR 2016",
                        "field_id": 1349,
                        "type": "SECONDARY_TRAMLINE",
                        "length": 1176.0
                    }
                }, {
                    "geometry": {
                        "type": "LineString",
                        "coordinates": [[-0.5392460960972871, 53.97253777980655], [-0.5385487269001885, 53.969130203923385]]
                    },
                    "type": "Feature",
                    "properties": {
                        "field_tramline_slug": "6c32e274-cb26-4ee9-a485-bb0dd5cdd8b7",
                        "field_slug": "f95120e4-d188-11e5-a7a3-f23c9118e215",
                        "name": "Bainton WOSR 2016_5",
                        "field_name": "Bainton WOSR 2016",
                        "field_id": 1349,
                        "type": "TERTIARY_TRAMLINE",
                        "length": 1176.0
                    }
                }, {
                    "geometry": {
                        "type": "LineString",
                        "coordinates": [[-0.5393368069347783, 53.97253087519772], [-0.5386395316234722, 53.96912379431531]]
                    },
                    "type": "Feature",
                    "properties": {
                        "field_tramline_slug": "43604da4-e0c5-447b-a19a-ae4bd6a3c653",
                        "field_slug": "f95120e4-d188-11e5-a7a3-f23c9118e215",
                        "name": "Bainton WOSR 2016_6",
                        "field_name": "Bainton WOSR 2016",
                        "field_id": 1349,
                        "type": "PRIMARY_TRAMLINE",
                        "length": 1176.0
                    }
                }, {
                    "geometry": {
                        "type": "LineString",
                        "coordinates": [[-0.539427517757804, 53.97252397058999], [-0.5387303363344031, 53.969117384708106]]
                    },
                    "type": "Feature",
                    "properties": {
                        "field_tramline_slug": "7f780aad-3670-47b5-9293-d5ba7aadd255",
                        "field_slug": "f95120e4-d188-11e5-a7a3-f23c9118e215",
                        "name": "Bainton WOSR 2016_7",
                        "field_name": "Bainton WOSR 2016",
                        "field_id": 1349,
                        "type": "TERTIARY_TRAMLINE",
                        "length": 1176.0
                    }
                }, {
                    "geometry": {
                        "type": "LineString",
                        "coordinates": [[-0.5395182285663602, 53.97251706598336], [-0.5388211410329763, 53.96911097510178]]
                    },
                    "type": "Feature",
                    "properties": {
                        "field_tramline_slug": "f5eda3dc-47ca-47d4-b98c-aa8b07e23a0f",
                        "field_slug": "f95120e4-d188-11e5-a7a3-f23c9118e215",
                        "name": "Bainton WOSR 2016_8",
                        "field_name": "Bainton WOSR 2016",
                        "field_id": 1349,
                        "type": "SECONDARY_TRAMLINE",
                        "length": 1176.0
                    }
                }, {
                    "geometry": {
                        "type": "LineString",
                        "coordinates": [[-0.5396089393604474, 53.97251016137783], [-0.5389119457191952, 53.969104565496316]]
                    },
                    "type": "Feature",
                    "properties": {
                        "field_tramline_slug": "dc821b75-013d-4308-89f2-ce21d032f32b",
                        "field_slug": "f95120e4-d188-11e5-a7a3-f23c9118e215",
                        "name": "Bainton WOSR 2016_9",
                        "field_name": "Bainton WOSR 2016",
                        "field_id": 1349,
                        "type": "TERTIARY_TRAMLINE",
                        "length": 1176.0
                    }
                }, {
                    "geometry": {
                        "type": "LineString",
                        "coordinates": [[-0.5396996501400672, 53.97250325677341], [-0.5390027503930584, 53.969098155891736]]
                    },
                    "type": "Feature",
                    "properties": {
                        "field_tramline_slug": "bd95577d-9a36-4c46-8e5b-a704223daa3d",
                        "field_slug": "f95120e4-d188-11e5-a7a3-f23c9118e215",
                        "name": "Bainton WOSR 2016_10",
                        "field_name": "Bainton WOSR 2016",
                        "field_id": 1349,
                        "type": "PRIMARY_TRAMLINE",
                        "length": 1176.0
                    }
                }, {
                    "geometry": {
                        "type": "LineString",
                        "coordinates": [[-0.5397903609052155, 53.97249635217008], [-0.5390935550545656, 53.96909174628802]]
                    },
                    "type": "Feature",
                    "properties": {
                        "field_tramline_slug": "c0d0fed2-97c7-49f0-9d6d-856978539e9f",
                        "field_slug": "f95120e4-d188-11e5-a7a3-f23c9118e215",
                        "name": "Bainton WOSR 2016_11",
                        "field_name": "Bainton WOSR 2016",
                        "field_id": 1349,
                        "type": "TERTIARY_TRAMLINE",
                        "length": 1176.0
                    }
                }, {
                    "geometry": {
                        "type": "LineString",
                        "coordinates": [[-0.5398810716559015, 53.97248944756786], [-0.5391843597037203, 53.96908533668518]]
                    },
                    "type": "Feature",
                    "properties": {
                        "field_tramline_slug": "c0ba2bf6-3592-4bcc-9441-a0372e3ad678",
                        "field_slug": "f95120e4-d188-11e5-a7a3-f23c9118e215",
                        "name": "Bainton WOSR 2016_12",
                        "field_name": "Bainton WOSR 2016",
                        "field_id": 1349,
                        "type": "SECONDARY_TRAMLINE",
                        "length": 1176.0
                    }
                }, {
                    "geometry": {
                        "type": "LineString",
                        "coordinates": [[-0.5399717823921132, 53.97248254296674], [-0.539275164340516, 53.96907892708321]]
                    },
                    "type": "Feature",
                    "properties": {
                        "field_tramline_slug": "bb0859fc-8913-4709-a6f3-170c6f736ad7",
                        "field_slug": "f95120e4-d188-11e5-a7a3-f23c9118e215",
                        "name": "Bainton WOSR 2016_13",
                        "field_name": "Bainton WOSR 2016",
                        "field_id": 1349,
                        "type": "TERTIARY_TRAMLINE",
                        "length": 1176.0
                    }
                }, {
                    "geometry": {
                        "type": "LineString",
                        "coordinates": [[-0.5400624931138582, 53.97247563836672], [-0.5393659689649589, 53.96907251748212]]
                    },
                    "type": "Feature",
                    "properties": {
                        "field_tramline_slug": "3798af81-ad9c-4757-99ea-901489a7c9ee",
                        "field_slug": "f95120e4-d188-11e5-a7a3-f23c9118e215",
                        "name": "Bainton WOSR 2016_14",
                        "field_name": "Bainton WOSR 2016",
                        "field_id": 1349,
                        "type": "PRIMARY_TRAMLINE",
                        "length": 1176.0
                    }
                }, {
                    "geometry": {
                        "type": "LineString",
                        "coordinates": [[-0.5401532038211406, 53.9724687337678], [-0.5394567735770484, 53.96906610788189]]
                    },
                    "type": "Feature",
                    "properties": {
                        "field_tramline_slug": "7c59674f-7c27-4838-a835-cc52a1f20a79",
                        "field_slug": "f95120e4-d188-11e5-a7a3-f23c9118e215",
                        "name": "Bainton WOSR 2016_15",
                        "field_name": "Bainton WOSR 2016",
                        "field_id": 1349,
                        "type": "TERTIARY_TRAMLINE",
                        "length": 1176.0
                    }
                }, {
                    "geometry": {
                        "type": "LineString",
                        "coordinates": [[-0.5402439145139468, 53.97246182916998], [-0.5395475781767775, 53.969059698282535]]
                    },
                    "type": "Feature",
                    "properties": {
                        "field_tramline_slug": "0416376e-3428-4293-91df-8ec1de8ac4b5",
                        "field_slug": "f95120e4-d188-11e5-a7a3-f23c9118e215",
                        "name": "Bainton WOSR 2016_16",
                        "field_name": "Bainton WOSR 2016",
                        "field_id": 1349,
                        "type": "SECONDARY_TRAMLINE",
                        "length": 1176.0
                    }
                }, {
                    "geometry": {
                        "type": "LineString",
                        "coordinates": [[-0.5403346251922916, 53.972454924573256], [-0.5396383827641583, 53.96905328868406]]
                    },
                    "type": "Feature",
                    "properties": {
                        "field_tramline_slug": "6a0ecf30-077d-42aa-b3e8-ecff86bbb167",
                        "field_slug": "f95120e4-d188-11e5-a7a3-f23c9118e215",
                        "name": "Bainton WOSR 2016_17",
                        "field_name": "Bainton WOSR 2016",
                        "field_id": 1349,
                        "type": "TERTIARY_TRAMLINE",
                        "length": 1176.0
                    }
                }, {
                    "geometry": {
                        "type": "LineString",
                        "coordinates": [[-0.5404253358561656, 53.97244801997764], [-0.5397291873391806, 53.96904687908645]]
                    },
                    "type": "Feature",
                    "properties": {
                        "field_tramline_slug": "0c513227-790b-4dc4-8973-9fa00f1b7022",
                        "field_slug": "f95120e4-d188-11e5-a7a3-f23c9118e215",
                        "name": "Bainton WOSR 2016_18",
                        "field_name": "Bainton WOSR 2016",
                        "field_id": 1349,
                        "type": "PRIMARY_TRAMLINE",
                        "length": 1176.0
                    }
                }, {
                    "geometry": {
                        "type": "LineString",
                        "coordinates": [[-0.540516046505572, 53.97244111538313], [-0.5398199919018503, 53.96904046948971]]
                    },
                    "type": "Feature",
                    "properties": {
                        "field_tramline_slug": "c98196b8-5b40-4c0a-930c-f5080cbcb509",
                        "field_slug": "f95120e4-d188-11e5-a7a3-f23c9118e215",
                        "name": "Bainton WOSR 2016_19",
                        "field_name": "Bainton WOSR 2016",
                        "field_id": 1349,
                        "type": "TERTIARY_TRAMLINE",
                        "length": 1176.0
                    }
                }, {
                    "geometry": {
                        "type": "LineString",
                        "coordinates": [[-0.5406067571405123, 53.972434210789714], [-0.539910796452164, 53.96903405989385]]
                    },
                    "type": "Feature",
                    "properties": {
                        "field_tramline_slug": "d0d7f6bf-b0ef-47f3-8ef3-2ffb65a75298",
                        "field_slug": "f95120e4-d188-11e5-a7a3-f23c9118e215",
                        "name": "Bainton WOSR 2016_20",
                        "field_name": "Bainton WOSR 2016",
                        "field_id": 1349,
                        "type": "SECONDARY_TRAMLINE",
                        "length": 1176.0
                    }
                }, {
                    "geometry": {
                        "type": "LineString",
                        "coordinates": [[-0.5406974677609845, 53.9724273061974], [-0.5400016009901238, 53.969027650298855]]
                    },
                    "type": "Feature",
                    "properties": {
                        "field_tramline_slug": "c2302a1f-ca20-4e2c-9836-addc008cb9b3",
                        "field_slug": "f95120e4-d188-11e5-a7a3-f23c9118e215",
                        "name": "Bainton WOSR 2016_21",
                        "field_name": "Bainton WOSR 2016",
                        "field_id": 1349,
                        "type": "TERTIARY_TRAMLINE",
                        "length": 1176.0
                    }
                }, {
                    "geometry": {
                        "type": "LineString",
                        "coordinates": [[-0.5407881783669888, 53.97242040160619], [-0.5400924055157285, 53.969021240704734]]
                    },
                    "type": "Feature",
                    "properties": {
                        "field_tramline_slug": "c7b67fda-4595-4534-aa3f-38bbb19d78b0",
                        "field_slug": "f95120e4-d188-11e5-a7a3-f23c9118e215",
                        "name": "Bainton WOSR 2016_22",
                        "field_name": "Bainton WOSR 2016",
                        "field_id": 1349,
                        "type": "PRIMARY_TRAMLINE",
                        "length": 1176.0
                    }
                }, {
                    "geometry": {
                        "type": "LineString",
                        "coordinates": [[-0.5408788889585244, 53.97241349701608], [-0.5401832100289791, 53.96901483111149]]
                    },
                    "type": "Feature",
                    "properties": {
                        "field_tramline_slug": "c34fb7ff-8aaa-4fb8-879e-b881b8bcfb1f",
                        "field_slug": "f95120e4-d188-11e5-a7a3-f23c9118e215",
                        "name": "Bainton WOSR 2016_23",
                        "field_name": "Bainton WOSR 2016",
                        "field_id": 1349,
                        "type": "TERTIARY_TRAMLINE",
                        "length": 1176.0
                    }
                }, {
                    "geometry": {
                        "type": "LineString",
                        "coordinates": [[-0.5409695995355969, 53.97240659242707], [-0.5402740145298779, 53.96900842151911]]
                    },
                    "type": "Feature",
                    "properties": {
                        "field_tramline_slug": "681100d0-c8f3-4a8c-a1d0-76ae0e9d346c",
                        "field_slug": "f95120e4-d188-11e5-a7a3-f23c9118e215",
                        "name": "Bainton WOSR 2016_24",
                        "field_name": "Bainton WOSR 2016",
                        "field_id": 1349,
                        "type": "SECONDARY_TRAMLINE",
                        "length": 1176.0
                    }
                }, {
                    "geometry": {
                        "type": "LineString",
                        "coordinates": [[-0.5410603100981989, 53.972399687839165], [-0.5403648190184195, 53.96900201192761]]
                    },
                    "type": "Feature",
                    "properties": {
                        "field_tramline_slug": "01c2a14c-66e3-4748-a9b0-33e511db6c37",
                        "field_slug": "f95120e4-d188-11e5-a7a3-f23c9118e215",
                        "name": "Bainton WOSR 2016_25",
                        "field_name": "Bainton WOSR 2016",
                        "field_id": 1349,
                        "type": "TERTIARY_TRAMLINE",
                        "length": 1176.0
                    }
                }, {
                    "geometry": {
                        "type": "LineString",
                        "coordinates": [[-0.5411510206463341, 53.97239278325235], [-0.5404556234946071, 53.968995602336975]]
                    },
                    "type": "Feature",
                    "properties": {
                        "field_tramline_slug": "7713b61e-2484-454d-b60e-5de5769b133c",
                        "field_slug": "f95120e4-d188-11e5-a7a3-f23c9118e215",
                        "name": "Bainton WOSR 2016_26",
                        "field_name": "Bainton WOSR 2016",
                        "field_id": 1349,
                        "type": "PRIMARY_TRAMLINE",
                        "length": 1176.0
                    }
                }, {
                    "geometry": {
                        "type": "LineString",
                        "coordinates": [[-0.5412417311800027, 53.97238587866665], [-0.5405464279584424, 53.968989192747216]]
                    },
                    "type": "Feature",
                    "properties": {
                        "field_tramline_slug": "b032a441-f0c2-4d9b-9e51-dcdf781fe38c",
                        "field_slug": "f95120e4-d188-11e5-a7a3-f23c9118e215",
                        "name": "Bainton WOSR 2016_27",
                        "field_name": "Bainton WOSR 2016",
                        "field_id": 1349,
                        "type": "TERTIARY_TRAMLINE",
                        "length": 1176.0
                    }
                }, {
                    "geometry": {
                        "type": "LineString",
                        "coordinates": [[-0.541332441699207, 53.97237897408205], [-0.5406372324099258, 53.96898278315833]]
                    },
                    "type": "Feature",
                    "properties": {
                        "field_tramline_slug": "c560642b-7899-45f7-9005-3e410e7af433",
                        "field_slug": "f95120e4-d188-11e5-a7a3-f23c9118e215",
                        "name": "Bainton WOSR 2016_28",
                        "field_name": "Bainton WOSR 2016",
                        "field_id": 1349,
                        "type": "SECONDARY_TRAMLINE",
                        "length": 1176.0
                    }
                }, {
                    "geometry": {
                        "type": "LineString",
                        "coordinates": [[-0.5414231522039383, 53.97237206949854], [-0.5407280368490489, 53.968976373570314]]
                    },
                    "type": "Feature",
                    "properties": {
                        "field_tramline_slug": "9609259d-beee-487f-9a6e-05795277b155",
                        "field_slug": "f95120e4-d188-11e5-a7a3-f23c9118e215",
                        "name": "Bainton WOSR 2016_29",
                        "field_name": "Bainton WOSR 2016",
                        "field_id": 1349,
                        "type": "TERTIARY_TRAMLINE",
                        "length": 1176.0
                    }
                }, {
                    "geometry": {
                        "type": "LineString",
                        "coordinates": [[-0.5415138626942059, 53.97236516491614], [-0.5408188412758199, 53.96896996398317]]
                    },
                    "type": "Feature",
                    "properties": {
                        "field_tramline_slug": "afff2695-d8f9-43e0-9f99-6a6b08e431c4",
                        "field_slug": "f95120e4-d188-11e5-a7a3-f23c9118e215",
                        "name": "Bainton WOSR 2016_30",
                        "field_name": "Bainton WOSR 2016",
                        "field_id": 1349,
                        "type": "PRIMARY_TRAMLINE",
                        "length": 1176.0
                    }
                }, {
                    "geometry": {
                        "type": "LineString",
                        "coordinates": [[-0.5416045731700104, 53.97235826033484], [-0.540909645690241, 53.9689635543969]]
                    },
                    "type": "Feature",
                    "properties": {
                        "field_tramline_slug": "4a19e9a4-5f02-47ef-aadd-4dc2c66951d1",
                        "field_slug": "f95120e4-d188-11e5-a7a3-f23c9118e215",
                        "name": "Bainton WOSR 2016_31",
                        "field_name": "Bainton WOSR 2016",
                        "field_id": 1349,
                        "type": "TERTIARY_TRAMLINE",
                        "length": 1176.0
                    }
                }, {
                    "geometry": {
                        "type": "LineString",
                        "coordinates": [[-0.5416952836313439, 53.97235135575464], [-0.541000450092307, 53.9689571448115]]
                    },
                    "type": "Feature",
                    "properties": {
                        "field_tramline_slug": "f71a60d5-8292-4dc0-ac11-8e230856d5df",
                        "field_slug": "f95120e4-d188-11e5-a7a3-f23c9118e215",
                        "name": "Bainton WOSR 2016_32",
                        "field_name": "Bainton WOSR 2016",
                        "field_id": 1349,
                        "type": "SECONDARY_TRAMLINE",
                        "length": 1176.0
                    }
                }, {
                    "geometry": {
                        "type": "LineString",
                        "coordinates": [[-0.541785994078214, 53.972344451175545], [-0.5410912544820201, 53.96895073522697]]
                    },
                    "type": "Feature",
                    "properties": {
                        "field_tramline_slug": "a149ccf8-48a7-443b-92e8-f44489ea8994",
                        "field_slug": "f95120e4-d188-11e5-a7a3-f23c9118e215",
                        "name": "Bainton WOSR 2016_33",
                        "field_name": "Bainton WOSR 2016",
                        "field_id": 1349,
                        "type": "TERTIARY_TRAMLINE",
                        "length": 1176.0
                    }
                }, {
                    "geometry": {
                        "type": "LineString",
                        "coordinates": [[-0.5418767045106164, 53.972337546597544], [-0.5411820588593786, 53.968944325643314]]
                    },
                    "type": "Feature",
                    "properties": {
                        "field_tramline_slug": "9f3dfcd0-fa18-4b0c-85a9-42a0d3c4a398",
                        "field_slug": "f95120e4-d188-11e5-a7a3-f23c9118e215",
                        "name": "Bainton WOSR 2016_34",
                        "field_name": "Bainton WOSR 2016",
                        "field_id": 1349,
                        "type": "PRIMARY_TRAMLINE",
                        "length": 1176.0
                    }
                }, {
                    "geometry": {
                        "type": "LineString",
                        "coordinates": [[-0.54196741492855, 53.97233064202065], [-0.5412728632243821, 53.96893791606053]]
                    },
                    "type": "Feature",
                    "properties": {
                        "field_tramline_slug": "23b9f742-e375-4076-8d1e-dd7dcbc56b80",
                        "field_slug": "f95120e4-d188-11e5-a7a3-f23c9118e215",
                        "name": "Bainton WOSR 2016_35",
                        "field_name": "Bainton WOSR 2016",
                        "field_id": 1349,
                        "type": "TERTIARY_TRAMLINE",
                        "length": 1176.0
                    }
                }, {
                    "geometry": {
                        "type": "LineString",
                        "coordinates": [[-0.5420581253320202, 53.97232373744485], [-0.5413636675770348, 53.96893150647862]]
                    },
                    "type": "Feature",
                    "properties": {
                        "field_tramline_slug": "c19506bc-1ab0-4d02-b52d-79cdbdd23dc3",
                        "field_slug": "f95120e4-d188-11e5-a7a3-f23c9118e215",
                        "name": "Bainton WOSR 2016_36",
                        "field_name": "Bainton WOSR 2016",
                        "field_id": 1349,
                        "type": "SECONDARY_TRAMLINE",
                        "length": 1176.0
                    }
                }, {
                    "geometry": {
                        "type": "LineString",
                        "coordinates": [[-0.542148835721023, 53.972316832870156], [-0.5414544719173358, 53.96892509689758]]
                    },
                    "type": "Feature",
                    "properties": {
                        "field_tramline_slug": "0fa9670a-35fd-4ff9-8d9c-e904e9642e6c",
                        "field_slug": "f95120e4-d188-11e5-a7a3-f23c9118e215",
                        "name": "Bainton WOSR 2016_37",
                        "field_name": "Bainton WOSR 2016",
                        "field_id": 1349,
                        "type": "TERTIARY_TRAMLINE",
                        "length": 1176.0
                    }
                }, {
                    "geometry": {
                        "type": "LineString",
                        "coordinates": [[-0.5422395460955612, 53.97230992829657], [-0.5415452762452801, 53.96891868731741]]
                    },
                    "type": "Feature",
                    "properties": {
                        "field_tramline_slug": "d37c4654-b762-40a2-9cab-89d4a10d93da",
                        "field_slug": "f95120e4-d188-11e5-a7a3-f23c9118e215",
                        "name": "Bainton WOSR 2016_38",
                        "field_name": "Bainton WOSR 2016",
                        "field_id": 1349,
                        "type": "PRIMARY_TRAMLINE",
                        "length": 1176.0
                    }
                }, {
                    "geometry": {
                        "type": "LineString",
                        "coordinates": [[-0.5423302564556327, 53.97230302372407], [-0.5416360805608724, 53.96891227773811]]
                    },
                    "type": "Feature",
                    "properties": {
                        "field_tramline_slug": "cf0b2910-8a0a-4b38-b699-fbe415f4a56a",
                        "field_slug": "f95120e4-d188-11e5-a7a3-f23c9118e215",
                        "name": "Bainton WOSR 2016_39",
                        "field_name": "Bainton WOSR 2016",
                        "field_id": 1349,
                        "type": "TERTIARY_TRAMLINE",
                        "length": 1176.0
                    }
                }, {
                    "geometry": {
                        "type": "LineString",
                        "coordinates": [[-0.5424209668012374, 53.97229611915268], [-0.5417268848641136, 53.968905868159695]]
                    },
                    "type": "Feature",
                    "properties": {
                        "field_tramline_slug": "301f7390-88a6-4c90-abff-48e75677aaf4",
                        "field_slug": "f95120e4-d188-11e5-a7a3-f23c9118e215",
                        "name": "Bainton WOSR 2016_40",
                        "field_name": "Bainton WOSR 2016",
                        "field_id": 1349,
                        "type": "SECONDARY_TRAMLINE",
                        "length": 1176.0
                    }
                }, {
                    "geometry": {
                        "type": "LineString",
                        "coordinates": [[-0.5424859252259647, 53.97216343044473], [-0.5418176891550012, 53.968899458582136]]
                    },
                    "type": "Feature",
                    "properties": {
                        "field_tramline_slug": "4cb2aa76-1769-4ddc-8704-466702e310bf",
                        "field_slug": "f95120e4-d188-11e5-a7a3-f23c9118e215",
                        "name": "Bainton WOSR 2016_41",
                        "field_name": "Bainton WOSR 2016",
                        "field_id": 1349,
                        "type": "TERTIARY_TRAMLINE",
                        "length": 1176.0
                    }
                }, {
                    "geometry": {
                        "type": "LineString",
                        "coordinates": [[-0.5425387910519143, 53.97197167930559], [-0.5419084934335342, 53.96889304900546]]
                    },
                    "type": "Feature",
                    "properties": {
                        "field_tramline_slug": "4b57890c-fac9-4ab1-92cf-1e41eb7bca9f",
                        "field_slug": "f95120e4-d188-11e5-a7a3-f23c9118e215",
                        "name": "Bainton WOSR 2016_42",
                        "field_name": "Bainton WOSR 2016",
                        "field_id": 1349,
                        "type": "PRIMARY_TRAMLINE",
                        "length": 1176.0
                    }
                }, {
                    "geometry": {
                        "type": "LineString",
                        "coordinates": [[-0.5425916564075828, 53.97177992987222], [-0.5419992976997159, 53.96888663942965]]
                    },
                    "type": "Feature",
                    "properties": {
                        "field_tramline_slug": "04fe95a4-8986-49c4-9647-e214c85e7df9",
                        "field_slug": "f95120e4-d188-11e5-a7a3-f23c9118e215",
                        "name": "Bainton WOSR 2016_43",
                        "field_name": "Bainton WOSR 2016",
                        "field_id": 1349,
                        "type": "TERTIARY_TRAMLINE",
                        "length": 1176.0
                    }
                }, {
                    "geometry": {
                        "type": "LineString",
                        "coordinates": [[-0.5426445212929769, 53.97158818214459], [-0.5420901019535459, 53.96888022985471]]
                    },
                    "type": "Feature",
                    "properties": {
                        "field_tramline_slug": "11046b09-ad43-4890-814b-4d9ec1b9dae5",
                        "field_slug": "f95120e4-d188-11e5-a7a3-f23c9118e215",
                        "name": "Bainton WOSR 2016_44",
                        "field_name": "Bainton WOSR 2016",
                        "field_id": 1349,
                        "type": "SECONDARY_TRAMLINE",
                        "length": 1176.0
                    }
                }, {
                    "geometry": {
                        "type": "LineString",
                        "coordinates": [[-0.542697385708103, 53.97139643612269], [-0.5421809061950208, 53.96887382028065]]
                    },
                    "type": "Feature",
                    "properties": {
                        "field_tramline_slug": "cbbc999e-83d6-49d0-b62f-a1ead86a9c5a",
                        "field_slug": "f95120e4-d188-11e5-a7a3-f23c9118e215",
                        "name": "Bainton WOSR 2016_45",
                        "field_name": "Bainton WOSR 2016",
                        "field_id": 1349,
                        "type": "TERTIARY_TRAMLINE",
                        "length": 1176.0
                    }
                }, {
                    "geometry": {
                        "type": "LineString",
                        "coordinates": [[-0.5427074432373047, 53.97099561672919], [-0.542271710424148, 53.96886741070746]]
                    },
                    "type": "Feature",
                    "properties": {
                        "field_tramline_slug": "5f785eec-19b8-41ef-8654-be5230fb999e",
                        "field_slug": "f95120e4-d188-11e5-a7a3-f23c9118e215",
                        "name": "Bainton WOSR 2016_46",
                        "field_name": "Bainton WOSR 2016",
                        "field_id": 1349,
                        "type": "PRIMARY_TRAMLINE",
                        "length": 1176.0
                    }
                }, {
                    "geometry": {
                        "type": "LineString",
                        "coordinates": [[-0.5427074432373047, 53.97054568332671], [-0.5423625146409169, 53.96886100113514]]
                    },
                    "type": "Feature",
                    "properties": {
                        "field_tramline_slug": "5f0ef57c-b4ba-4bfa-8152-384638f7ded8",
                        "field_slug": "f95120e4-d188-11e5-a7a3-f23c9118e215",
                        "name": "Bainton WOSR 2016_47",
                        "field_name": "Bainton WOSR 2016",
                        "field_id": 1349,
                        "type": "TERTIARY_TRAMLINE",
                        "length": 1176.0
                    }
                }]
            }, 1, 48
        ]
    };

    this.getTrialPoint = function () {
        return [
            {
                "harvest_year": 2016,
                "trial_sites": {
                    "type": "FeatureCollection",
                    "features": [{
                        "geometry": {"type": "Point", "coordinates": [0.13309658, 53.29641885]},
                        "type": "Feature",
                        "properties": {
                            "site_name": "Aby",
                            "farm_name": "Aby",
                            "trial_slug": "aby-aby",
                            "site_code": null,
                            "farm_id": 108,
                            "protocols": [{
                                "harvest_year": 2016,
                                "trial_code": "WW16-9039",
                                "protocol_slug": "f9cef4c4-b478-11e5-953b-f23c9118e215",
                                "title": "WW Variety demonstration plots"
                            }],
                            "farm_slug": "ian-midgley-aby"
                        }
                    }, {
                        "geometry": {"type": "Point", "coordinates": [-0.54605484, 53.96643741]},
                        "type": "Feature",
                        "properties": {
                            "site_name": "Bainton",
                            "farm_name": "Bainton",
                            "trial_slug": "bainton-bainton",
                            "site_code": null,
                            "farm_id": 88,
                            "protocols": [{
                                "harvest_year": 2016,
                                "trial_code": "XX WW16-9125",
                                "protocol_slug": "15f7044e-0c5c-11e6-a39f-f23c9118e215",
                                "title": "Early Sown Wheat Inputs"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "WOR16-605",
                                "protocol_slug": "6d760814-b2b6-11e5-a8d5-f23c9118e215",
                                "title": "NTN Varieties Trial (with slots)"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "XX WW16-9087",
                                "protocol_slug": "86fdf0f4-cf20-11e5-8435-f23c9118e215",
                                "title": "Members fungicide strategies 2016"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "SB16-9138",
                                "protocol_slug": "1e2e6bac-0acc-11e6-9b31-f23c9118e215",
                                "title": "NTN fungicide x N (North)"
                            }],
                            "farm_slug": "niab-niab-bainton"
                        }
                    }, {
                        "geometry": {"type": "Point", "coordinates": [-0.21196693, 53.31588074]},
                        "type": "Feature",
                        "properties": {
                            "site_name": "Benniworth Farm",
                            "farm_name": "Benniworth",
                            "trial_slug": "open-day-2015-benniworth",
                            "site_code": null,
                            "farm_id": 92,
                            "protocols": [{
                                "harvest_year": 2016,
                                "trial_code": "WOR16-638",
                                "protocol_slug": "5fd25992-b536-11e5-858b-f23c9118e215",
                                "title": "Blackgrass control in oilseed rape"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "WW16-9001 BE",
                                "protocol_slug": "eeb7b010-15f0-11e6-acf8-f23c9118e215",
                                "title": "Drilling date and herbicide programme"
                            }],
                            "farm_slug": "niab-niab-niab-benniworth"
                        }
                    }, {
                        "geometry": {"type": "Point", "coordinates": [-2.01407075, 55.66942891]},
                        "type": "Feature",
                        "properties": {
                            "site_name": "Berwick",
                            "farm_name": "Berwick",
                            "trial_slug": "berwick-berwick",
                            "site_code": null,
                            "farm_id": 107,
                            "protocols": [{
                                "harvest_year": 2016,
                                "trial_code": "WW16-9119",
                                "protocol_slug": "6b09d374-b538-11e5-b9b1-f23c9118e215",
                                "title": "Variety x Fungicide"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "WOR16-9121",
                                "protocol_slug": "a4c44b8e-b557-11e5-8d0e-f23c9118e215",
                                "title": "Disease control and yield penalty in winter oilseed rape"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "WW16-9039",
                                "protocol_slug": "f9cef4c4-b478-11e5-953b-f23c9118e215",
                                "title": "WW Variety demonstration plots"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "WW16-000",
                                "protocol_slug": "ab500380-b520-11e5-92ac-f23c9118e215",
                                "title": "NIAB Agronomy Cup"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "WW16-9101",
                                "protocol_slug": "86a36d70-b524-11e5-bb9f-f23c9118e215",
                                "title": "Vulpia control options"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "XX WW16-9087",
                                "protocol_slug": "86fdf0f4-cf20-11e5-8435-f23c9118e215",
                                "title": "Members fungicide strategies 2016"
                            }],
                            "farm_slug": "ian-midgley-berwick"
                        }
                    }, {
                        "geometry": {"type": "Point", "coordinates": [-1.093809, 51.170064]},
                        "type": "Feature",
                        "properties": {
                            "site_name": "Bradley",
                            "farm_name": "Bradley",
                            "trial_slug": "bradley-bradley",
                            "site_code": null,
                            "farm_id": 98,
                            "protocols": [],
                            "farm_slug": "ian-midgley-bradley"
                        }
                    }, {
                        "geometry": {"type": "Point", "coordinates": [0.09614915, 52.22193875]},
                        "type": "Feature",
                        "properties": {
                            "site_name": "Cambridge",
                            "farm_name": "Cambridge",
                            "trial_slug": "cambridge-cambridge",
                            "site_code": null,
                            "farm_id": 93,
                            "protocols": [{
                                "harvest_year": 2016,
                                "trial_code": "WW16-009",
                                "protocol_slug": "6d94a148-b2b6-11e5-a8d5-f23c9118e215",
                                "title": "NTN blackgrass core programmes"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "WOR16-9121",
                                "protocol_slug": "a4c44b8e-b557-11e5-8d0e-f23c9118e215",
                                "title": "Disease control and yield penalty in winter oilseed rape"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "WOR16-606",
                                "protocol_slug": "0889c688-b55a-11e5-8784-f23c9118e215",
                                "title": "Slot trial for Clearfield varieties"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "WOR16-608",
                                "protocol_slug": "14e7c398-c41f-11e5-b602-f23c9118e215",
                                "title": "NTN TuYV Seed Treatments"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "WW16-TEST",
                                "protocol_slug": "d208199e-1142-11e6-ad8c-f23c9118e215",
                                "title": "TEST"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "CUF-002",
                                "protocol_slug": "3b7ca5a4-20ff-11e6-b71f-f23c9118e215",
                                "title": "CUFtest"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "WOR16-605",
                                "protocol_slug": "6d760814-b2b6-11e5-a8d5-f23c9118e215",
                                "title": "NTN Varieties Trial (with slots)"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "XX WW16-9098",
                                "protocol_slug": "40cd5486-b494-11e5-83e2-f23c9118e215",
                                "title": "Sowing date and variety choice for blackgrass control"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "WW16-000",
                                "protocol_slug": "ab500380-b520-11e5-92ac-f23c9118e215",
                                "title": "NIAB Agronomy Cup"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "WOR16-638",
                                "protocol_slug": "5fd25992-b536-11e5-858b-f23c9118e215",
                                "title": "Blackgrass control in oilseed rape"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "WOR16-9120",
                                "protocol_slug": "28a87918-b556-11e5-a8fe-f23c9118e215",
                                "title": "Investigation into flea beetle damage avoidance measures"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "WBN16-9122",
                                "protocol_slug": "83e9301c-11d4-11e6-927d-f23c9118e215",
                                "title": "Winter bean time of sowing x seed rate"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "WW16-9001 CB",
                                "protocol_slug": "20364576-15f5-11e6-86a8-f23c9118e215",
                                "title": "Drilling date and herbicide programme"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "WOR16-02701",
                                "protocol_slug": "26aafdc4-20d2-11e6-bfac-f23c9118e215",
                                "title": "Risk factors for Black grass control in OSR"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "WOR16-02701_copy_8mzS",
                                "protocol_slug": "3c1db085-58ae-11e6-bea6-34363bd14432",
                                "title": "Risk factors for Black grass control in OSR"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "CUF-002_copy_TNMw",
                                "protocol_slug": "3b51f51c-5b17-11e6-b2cc-34363bd14432",
                                "title": "CUFtest"
                            }],
                            "farm_slug": "niab-niab-niab-cambridge"
                        }
                    }, {
                        "geometry": {"type": "Point", "coordinates": [-0.6045819, 53.021631]},
                        "type": "Feature",
                        "properties": {
                            "site_name": "Caythorpe",
                            "farm_name": "Caythorpe",
                            "trial_slug": "caythorpe-caythorpe",
                            "site_code": null,
                            "farm_id": 103,
                            "protocols": [{
                                "harvest_year": 2016,
                                "trial_code": "WW16-9099",
                                "protocol_slug": "6d8bdd38-b2b6-11e5-a8d5-f23c9118e215",
                                "title": "NTN Future fungicide programmes"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "WW16-022",
                                "protocol_slug": "6d776f7e-b2b6-11e5-a8d5-f23c9118e215",
                                "title": "NTN milling wheat"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "WO16-9097",
                                "protocol_slug": "263d746a-b472-11e5-953b-f23c9118e215",
                                "title": "Winter and spring oat sowing dates"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "WW16-9039",
                                "protocol_slug": "f9cef4c4-b478-11e5-953b-f23c9118e215",
                                "title": "WW Variety demonstration plots"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "WW16-000",
                                "protocol_slug": "ab500380-b520-11e5-92ac-f23c9118e215",
                                "title": "NIAB Agronomy Cup"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "XX WW16-9087",
                                "protocol_slug": "86fdf0f4-cf20-11e5-8435-f23c9118e215",
                                "title": "Members fungicide strategies 2016"
                            }],
                            "farm_slug": "ian-midgley-caythorpe"
                        }
                    }, {
                        "geometry": {"type": "Point", "coordinates": [-0.01787424, 52.2381683]},
                        "type": "Feature",
                        "properties": {
                            "site_name": "Childerley",
                            "farm_name": "Childerley",
                            "trial_slug": "childerley-childerley",
                            "site_code": null,
                            "farm_id": 114,
                            "protocols": [],
                            "farm_slug": "ian-midgley-childerley"
                        }
                    }, {
                        "geometry": {"type": "Point", "coordinates": [-2.00811625, 51.69784484]},
                        "type": "Feature",
                        "properties": {
                            "site_name": "Cirencester",
                            "farm_name": "Cirencester",
                            "trial_slug": "cirencester-cirencester",
                            "site_code": null,
                            "farm_id": 86,
                            "protocols": [{
                                "harvest_year": 2016,
                                "trial_code": "WW16-9099",
                                "protocol_slug": "6d8bdd38-b2b6-11e5-a8d5-f23c9118e215",
                                "title": "NTN Future fungicide programmes"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "WW16-9091",
                                "protocol_slug": "6d8e8966-b2b6-11e5-a8d5-f23c9118e215",
                                "title": "Protectant fungicide programmes"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "SO16 -9136",
                                "protocol_slug": "f869f928-d497-11e5-b633-f23c9118e215",
                                "title": "Fungicide programmes for spring oats"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "SB16-9134",
                                "protocol_slug": "16f4b258-d4ab-11e5-8759-f23c9118e215",
                                "title": "Nitrogen, PGR & variety interaction in spring barley"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "SO16-9114",
                                "protocol_slug": "7c56d858-b460-11e5-83e2-f23c9118e215",
                                "title": "Nitrogen doses for spring oat varieties"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "WW16-9081",
                                "protocol_slug": "0f739cde-b47a-11e5-a71f-f23c9118e215",
                                "title": "Cirencester Variety Trial"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "WW16-9107",
                                "protocol_slug": "3af18b24-b492-11e5-92ac-f23c9118e215",
                                "title": "Variety x drilling date interactions"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "WW16-000",
                                "protocol_slug": "ab500380-b520-11e5-92ac-f23c9118e215",
                                "title": "NIAB Agronomy Cup"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "SB16-9135",
                                "protocol_slug": "3c9b6a4e-d4a4-11e5-8759-f23c9118e215",
                                "title": "Nitrogen/growth regulator interaction in spring barley"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "WB16-9132",
                                "protocol_slug": "a94f359c-e522-11e5-9a51-f23c9118e215",
                                "title": "Late sown hybrid winter barley varieties at Cirencester"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "SW16-9110",
                                "protocol_slug": "c5c3995e-15d6-11e6-80b6-f23c9118e215",
                                "title": "Spring wheat fungicide programmes"
                            }],
                            "farm_slug": "niab-niab-cirencester"
                        }
                    }, {
                        "geometry": {"type": "Point", "coordinates": [0.56123078, 52.07815759]},
                        "type": "Feature",
                        "properties": {
                            "site_name": "Clare",
                            "farm_name": "Clare",
                            "trial_slug": "clare-clare",
                            "site_code": null,
                            "farm_id": 111,
                            "protocols": [{
                                "harvest_year": 2016,
                                "trial_code": "WW16-009",
                                "protocol_slug": "6d94a148-b2b6-11e5-a8d5-f23c9118e215",
                                "title": "NTN blackgrass core programmes"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "WW16-9123",
                                "protocol_slug": "8057baf0-c426-11e5-8f0c-f23c9118e215",
                                "title": "Estimating the value of pre-em tank-mix additions"
                            }],
                            "farm_slug": "ian-midgley-clare"
                        }
                    }, {
                        "geometry": {"type": "Point", "coordinates": [0.74837923, 51.89631748]},
                        "type": "Feature",
                        "properties": {
                            "site_name": "Colchester",
                            "farm_name": "Colchester",
                            "trial_slug": "colchester-colchester",
                            "site_code": null,
                            "farm_id": 112,
                            "protocols": [{
                                "harvest_year": 2016,
                                "trial_code": "WW16-022",
                                "protocol_slug": "6d776f7e-b2b6-11e5-a8d5-f23c9118e215",
                                "title": "NTN milling wheat"
                            }],
                            "farm_slug": "ian-midgley-colchester"
                        }
                    }, {
                        "geometry": {"type": "Point", "coordinates": [-1.57620549, 54.4821501]},
                        "type": "Feature",
                        "properties": {
                            "site_name": "Croft",
                            "farm_name": "Croft",
                            "trial_slug": "croft-croft",
                            "site_code": null,
                            "farm_id": 106,
                            "protocols": [{
                                "harvest_year": 2016,
                                "trial_code": "WW16-9039",
                                "protocol_slug": "f9cef4c4-b478-11e5-953b-f23c9118e215",
                                "title": "WW Variety demonstration plots"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "XX WW16-9087",
                                "protocol_slug": "86fdf0f4-cf20-11e5-8435-f23c9118e215",
                                "title": "Members fungicide strategies 2016"
                            }],
                            "farm_slug": "ian-midgley-croft"
                        }
                    }, {
                        "geometry": {"type": "Point", "coordinates": [0.0984478, 52.24722101]},
                        "type": "Feature",
                        "properties": {
                            "site_name": "Demo Trial Site 1",
                            "farm_name": "Giles' Farm",
                            "trial_slug": "demo-trial-site-1-demo-farm-1",
                            "site_code": "DTS01",
                            "farm_id": 130,
                            "protocols": [{
                                "harvest_year": 2016,
                                "trial_code": "WW15-Demo 001",
                                "protocol_slug": "6d7d592a-b2b6-11e5-a8d5-f23c9118e215",
                                "title": "Variety/Fungicide Interaction Trial."
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "WW15-Demo 001_copy",
                                "protocol_slug": "56795088-ec3d-11e5-a0cc-f23c9118e215",
                                "title": "Variety/Fungicide Interaction Trial."
                            }],
                            "farm_slug": "e8bc6d0a-5867-11e5-9839-f23c9118e215"
                        }
                    }, {
                        "geometry": {"type": "Point", "coordinates": [0.0984478, 52.24722101]},
                        "type": "Feature",
                        "properties": {
                            "site_name": "Demo Trial Site 2",
                            "farm_name": "Giles' Farm",
                            "trial_slug": "demo-trial-site-2-demo-farm-1",
                            "site_code": "DTS02",
                            "farm_id": 130,
                            "protocols": [],
                            "farm_slug": "e8bc6d0a-5867-11e5-9839-f23c9118e215"
                        }
                    }, {
                        "geometry": {"type": "Point", "coordinates": [-0.443377, 54.005996]},
                        "type": "Feature",
                        "properties": {
                            "site_name": "Elmswell",
                            "farm_name": "Elmswell",
                            "trial_slug": "elmswell-elmswell",
                            "site_code": null,
                            "farm_id": 101,
                            "protocols": [{
                                "harvest_year": 2016,
                                "trial_code": "WW16-9091",
                                "protocol_slug": "6d8e8966-b2b6-11e5-a8d5-f23c9118e215",
                                "title": "Protectant fungicide programmes"
                            }],
                            "farm_slug": "ian-midgley-elmswell"
                        }
                    }, {
                        "geometry": {"type": "Point", "coordinates": [0.09614915, 52.22193875]},
                        "type": "Feature",
                        "properties": {
                            "site_name": "Hardwick",
                            "farm_name": "Cambridge",
                            "trial_slug": "us-s-uhardwick-farm-cambridge",
                            "site_code": "",
                            "farm_id": 93,
                            "protocols": [{
                                "harvest_year": 2016,
                                "trial_code": "WW16-9123",
                                "protocol_slug": "8057baf0-c426-11e5-8f0c-f23c9118e215",
                                "title": "Estimating the value of pre-em tank-mix additions"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "WB16-9129",
                                "protocol_slug": "2d0bbcdc-0d20-11e6-8d51-f23c9118e215",
                                "title": "NTN Black-grass control in Winter Barley"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "WB16-9126",
                                "protocol_slug": "41d3268a-15c4-11e6-acf8-f23c9118e215",
                                "title": "Nutrient VAR BG  Interaction min Bazooka demo"
                            }],
                            "farm_slug": "niab-niab-niab-cambridge"
                        }
                    }, {
                        "geometry": {"type": "Point", "coordinates": [-2.42516756, 52.77585793]},
                        "type": "Feature",
                        "properties": {
                            "site_name": "Harper Adams",
                            "farm_name": "Harper Adams",
                            "trial_slug": "harper-adams-harper-adams",
                            "site_code": null,
                            "farm_id": 94,
                            "protocols": [{
                                "harvest_year": 2016,
                                "trial_code": "WOR16-605",
                                "protocol_slug": "6d760814-b2b6-11e5-a8d5-f23c9118e215",
                                "title": "NTN Varieties Trial (with slots)"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "WW16-000",
                                "protocol_slug": "ab500380-b520-11e5-92ac-f23c9118e215",
                                "title": "NIAB Agronomy Cup"
                            }],
                            "farm_slug": "niab-niab-niab-harper-adams"
                        }
                    }, {
                        "geometry": {"type": "Point", "coordinates": [-1.32221639, 53.86623679]},
                        "type": "Feature",
                        "properties": {
                            "site_name": "Headley Hall",
                            "farm_name": "Headley Hall",
                            "trial_slug": "headley-hall-niab-headley-hall",
                            "site_code": null,
                            "farm_id": 90,
                            "protocols": [{
                                "harvest_year": 2016,
                                "trial_code": "WW16-9128",
                                "protocol_slug": "5847c406-0bc0-11e6-a761-f23c9118e215",
                                "title": "NTN G&D Monitoring"
                            }],
                            "farm_slug": "niab-niab-niab-headley-hall"
                        }
                    }, {
                        "geometry": {"type": "Point", "coordinates": [-2.75206447, 51.99865479]},
                        "type": "Feature",
                        "properties": {
                            "site_name": "Hereford",
                            "farm_name": "Hereford",
                            "trial_slug": "hereford-niab-hereford",
                            "site_code": null,
                            "farm_id": 91,
                            "protocols": [{
                                "harvest_year": 2016,
                                "trial_code": "WW16-9099",
                                "protocol_slug": "6d8bdd38-b2b6-11e5-a8d5-f23c9118e215",
                                "title": "NTN Future fungicide programmes"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "WOR16-9121",
                                "protocol_slug": "a4c44b8e-b557-11e5-8d0e-f23c9118e215",
                                "title": "Disease control and yield penalty in winter oilseed rape"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "WOR16-606",
                                "protocol_slug": "0889c688-b55a-11e5-8784-f23c9118e215",
                                "title": "Slot trial for Clearfield varieties"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "WW16-9128",
                                "protocol_slug": "5847c406-0bc0-11e6-a761-f23c9118e215",
                                "title": "NTN G&D Monitoring"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "WOR16-9131 HE",
                                "protocol_slug": "e020a466-15ec-11e6-a69f-f23c9118e215",
                                "title": "NTN WOR Grazing trial"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "WOR16-605",
                                "protocol_slug": "6d760814-b2b6-11e5-a8d5-f23c9118e215",
                                "title": "NTN Varieties Trial (with slots)"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "WW16-000",
                                "protocol_slug": "ab500380-b520-11e5-92ac-f23c9118e215",
                                "title": "NIAB Agronomy Cup"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "WW16-9083",
                                "protocol_slug": "440b6396-b533-11e5-ad3c-f23c9118e215",
                                "title": "Brome control programmes"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "SB16-9135",
                                "protocol_slug": "3c9b6a4e-d4a4-11e5-8759-f23c9118e215",
                                "title": "Nitrogen/growth regulator interaction in spring barley"
                            }],
                            "farm_slug": "niab-niab-niab-hereford"
                        }
                    }, {
                        "geometry": {"type": "Point", "coordinates": [0.17912865, 52.08893385]},
                        "type": "Feature",
                        "properties": {
                            "site_name": "Hinxton",
                            "farm_name": "Hinxton",
                            "trial_slug": "hinxton-hinxton",
                            "site_code": "",
                            "farm_id": 274,
                            "protocols": [{
                                "harvest_year": 2016,
                                "trial_code": "WW16-9128",
                                "protocol_slug": "5847c406-0bc0-11e6-a761-f23c9118e215",
                                "title": "NTN G&D Monitoring"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "WOR16-9130",
                                "protocol_slug": "f7efb776-0c87-11e6-9e79-f23c9118e215",
                                "title": "Control of Cabbage Stem Flea Beetle Larvae in Late Autumn"
                            }],
                            "farm_slug": "fdcdf4c6-0c66-11e6-84c4-f23c9118e215"
                        }
                    }, {
                        "geometry": {"type": "Point", "coordinates": [1.03228569, 52.55385685]},
                        "type": "Feature",
                        "properties": {
                            "site_name": "Morley",
                            "farm_name": "Morley",
                            "trial_slug": "morley-niab-morley",
                            "site_code": null,
                            "farm_id": 95,
                            "protocols": [{
                                "harvest_year": 2016,
                                "trial_code": "WB16-9040",
                                "protocol_slug": "5dead36c-b463-11e5-a541-f23c9118e215",
                                "title": "Winter barley variety-fungicide interaction trials"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "WOR16-606",
                                "protocol_slug": "0889c688-b55a-11e5-8784-f23c9118e215",
                                "title": "Slot trial for Clearfield varieties"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "SBT16-9131",
                                "protocol_slug": "629d7c94-c34e-11e5-b04c-f23c9118e215",
                                "title": "Nitrogen Requirements from Modern Sugar Beet Varieties"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "WB16-9133",
                                "protocol_slug": "832e8af4-c8ce-11e5-b010-f23c9118e215",
                                "title": "Winter barley - max yield"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "WOR16-605",
                                "protocol_slug": "6d760814-b2b6-11e5-a8d5-f23c9118e215",
                                "title": "NTN Varieties Trial (with slots)"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "WW16-026",
                                "protocol_slug": "6d9b75d6-b2b6-11e5-a8d5-f23c9118e215",
                                "title": "Sand/light land  wheat variety trial"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "WW16-9039",
                                "protocol_slug": "f9cef4c4-b478-11e5-953b-f23c9118e215",
                                "title": "WW Variety demonstration plots"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "WW16-000",
                                "protocol_slug": "ab500380-b520-11e5-92ac-f23c9118e215",
                                "title": "NIAB Agronomy Cup"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "WOR16-9120",
                                "protocol_slug": "28a87918-b556-11e5-a8fe-f23c9118e215",
                                "title": "Investigation into flea beetle damage avoidance measures"
                            }],
                            "farm_slug": "niab-niab-niab-morley"
                        }
                    }, {
                        "geometry": {"type": "Point", "coordinates": [-3.6568433, 50.57630795]},
                        "type": "Feature",
                        "properties": {
                            "site_name": "Newton Abbot",
                            "farm_name": "Newton Abbot",
                            "trial_slug": "newton-abbot-newton-abbot",
                            "site_code": null,
                            "farm_id": 97,
                            "protocols": [{
                                "harvest_year": 2016,
                                "trial_code": "WW16-000",
                                "protocol_slug": "ab500380-b520-11e5-92ac-f23c9118e215",
                                "title": "NIAB Agronomy Cup"
                            }],
                            "farm_slug": "niab-niab-niab-newton-abbot"
                        }
                    }, {
                        "geometry": {"type": "Point", "coordinates": [0.88548169, 51.81061389]},
                        "type": "Feature",
                        "properties": {
                            "site_name": "Peldon",
                            "farm_name": "Peldon",
                            "trial_slug": "peldon-peldon",
                            "site_code": null,
                            "farm_id": 109,
                            "protocols": [],
                            "farm_slug": "ian-midgley-peldon"
                        }
                    }, {
                        "geometry": {"type": "Point", "coordinates": [-0.382119, 52.250448]},
                        "type": "Feature",
                        "properties": {
                            "site_name": "Staughton",
                            "farm_name": "Staughton",
                            "trial_slug": "staughton-staughton",
                            "site_code": null,
                            "farm_id": 100,
                            "protocols": [],
                            "farm_slug": "ian-midgley-staughton"
                        }
                    }, {
                        "geometry": {"type": "Point", "coordinates": [1.10004902, 52.20096578]},
                        "type": "Feature",
                        "properties": {
                            "site_name": "Stonham",
                            "farm_name": "Stonham",
                            "trial_slug": "stonham-stonham",
                            "site_code": null,
                            "farm_id": 110,
                            "protocols": [],
                            "farm_slug": "ian-midgley-stonham"
                        }
                    }, {
                        "geometry": {"type": "Point", "coordinates": [-1.33028448, 51.16818362]},
                        "type": "Feature",
                        "properties": {
                            "site_name": "Sutton Scotney",
                            "farm_name": "Sutton Scotney",
                            "trial_slug": "sutton-scotney-sutton-scotney",
                            "site_code": null,
                            "farm_id": 87,
                            "protocols": [{
                                "harvest_year": 2016,
                                "trial_code": "WW16-9003",
                                "protocol_slug": "9410515c-3d51-11e6-850b-34363bd14432",
                                "title": "WW16-9003"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "WW16-9099",
                                "protocol_slug": "6d8bdd38-b2b6-11e5-a8d5-f23c9118e215",
                                "title": "NTN Future fungicide programmes"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "WOR16-9121",
                                "protocol_slug": "a4c44b8e-b557-11e5-8d0e-f23c9118e215",
                                "title": "Disease control and yield penalty in winter oilseed rape"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "WOR16-606",
                                "protocol_slug": "0889c688-b55a-11e5-8784-f23c9118e215",
                                "title": "Slot trial for Clearfield varieties"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "WOR16-608",
                                "protocol_slug": "14e7c398-c41f-11e5-b602-f23c9118e215",
                                "title": "NTN TuYV Seed Treatments"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "SB16-9134",
                                "protocol_slug": "16f4b258-d4ab-11e5-8759-f23c9118e215",
                                "title": "Nitrogen, PGR & variety interaction in spring barley"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "WOR16-605",
                                "protocol_slug": "6d760814-b2b6-11e5-a8d5-f23c9118e215",
                                "title": "NTN Varieties Trial (with slots)"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "WW16-022",
                                "protocol_slug": "6d776f7e-b2b6-11e5-a8d5-f23c9118e215",
                                "title": "NTN milling wheat"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "SO16-9114",
                                "protocol_slug": "7c56d858-b460-11e5-83e2-f23c9118e215",
                                "title": "Nitrogen doses for spring oat varieties"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "WO16-802",
                                "protocol_slug": "6a5a964a-b469-11e5-a220-f23c9118e215",
                                "title": "Nitrogen doses for new winter oat varieties"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "WO16-9097",
                                "protocol_slug": "263d746a-b472-11e5-953b-f23c9118e215",
                                "title": "Winter and spring oat sowing dates"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "WW16-9039",
                                "protocol_slug": "f9cef4c4-b478-11e5-953b-f23c9118e215",
                                "title": "WW Variety demonstration plots"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "WW16-000",
                                "protocol_slug": "ab500380-b520-11e5-92ac-f23c9118e215",
                                "title": "NIAB Agronomy Cup"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "WOR16-9120",
                                "protocol_slug": "28a87918-b556-11e5-a8fe-f23c9118e215",
                                "title": "Investigation into flea beetle damage avoidance measures"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "WW16-9127",
                                "protocol_slug": "7cf3a080-0d47-11e6-b5c4-f23c9118e215",
                                "title": "NTN Cirencester winter barley variety trial"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "WOR16-9131 SS",
                                "protocol_slug": "2ca97e8c-15ea-11e6-86a8-f23c9118e215",
                                "title": "NTN WOR Grazing trial"
                            }],
                            "farm_slug": "niab-niab-sutton-scotney"
                        }
                    }, {
                        "geometry": {"type": "Point", "coordinates": [-3.106849, 51.015344]},
                        "type": "Feature",
                        "properties": {
                            "site_name": "Taunton",
                            "farm_name": "Taunton",
                            "trial_slug": "tauton-taunton",
                            "site_code": null,
                            "farm_id": 99,
                            "protocols": [{
                                "harvest_year": 2016,
                                "trial_code": "WW16-9119",
                                "protocol_slug": "6b09d374-b538-11e5-b9b1-f23c9118e215",
                                "title": "Variety x Fungicide"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "WW16-9094",
                                "protocol_slug": "6d91525e-b2b6-11e5-a8d5-f23c9118e215",
                                "title": "CTL programmes"
                            }],
                            "farm_slug": "ian-midgley-taunton"
                        }
                    }, {
                        "geometry": {"type": "Point", "coordinates": [-4.30312157, 57.46385785]},
                        "type": "Feature",
                        "properties": {
                            "site_name": "Test Trial Sites FCR",
                            "farm_name": "Test Farm Test FCR",
                            "trial_slug": "test-trial-sites-fcr-test-farm-test-fcr",
                            "site_code": "FCR",
                            "farm_id": 128,
                            "protocols": [],
                            "farm_slug": "badb8e80-55f0-11e5-8ce8-f23c9118e215"
                        }
                    }, {
                        "geometry": {"type": "Point", "coordinates": [-1.64625406, 52.30468694]},
                        "type": "Feature",
                        "properties": {
                            "site_name": "Warwick",
                            "farm_name": "Warwick",
                            "trial_slug": "warwick-warwick",
                            "site_code": null,
                            "farm_id": 85,
                            "protocols": [{
                                "harvest_year": 2016,
                                "trial_code": "WB16-9040",
                                "protocol_slug": "5dead36c-b463-11e5-a541-f23c9118e215",
                                "title": "Winter barley variety-fungicide interaction trials"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "WW16-9119",
                                "protocol_slug": "6b09d374-b538-11e5-b9b1-f23c9118e215",
                                "title": "Variety x Fungicide"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "WW16-9094",
                                "protocol_slug": "6d91525e-b2b6-11e5-a8d5-f23c9118e215",
                                "title": "CTL programmes"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "WW16-9137",
                                "protocol_slug": "f8be395a-d949-11e5-af0c-f23c9118e215",
                                "title": "Nitrogen response in wheat"
                            }],
                            "farm_slug": "niab-niab-warwick"
                        }
                    }, {
                        "geometry": {"type": "Point", "coordinates": [-0.30577183, 53.27749339]},
                        "type": "Feature",
                        "properties": {
                            "site_name": "Wragby",
                            "farm_name": "Wragby",
                            "trial_slug": "wragby-wragby",
                            "site_code": null,
                            "farm_id": 113,
                            "protocols": [{
                                "harvest_year": 2016,
                                "trial_code": "WW16-009",
                                "protocol_slug": "6d94a148-b2b6-11e5-a8d5-f23c9118e215",
                                "title": "NTN blackgrass core programmes"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "WW16-9123",
                                "protocol_slug": "8057baf0-c426-11e5-8f0c-f23c9118e215",
                                "title": "Estimating the value of pre-em tank-mix additions"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "SW16-9115",
                                "protocol_slug": "4659f316-e485-11e5-8361-f23c9118e215",
                                "title": "Spring Cereals as a black-grass management option."
                            }],
                            "farm_slug": "ian-midgley-wragby"
                        }
                    }, {
                        "geometry": {"type": "Point", "coordinates": [0.99817067, 51.13774568]},
                        "type": "Feature",
                        "properties": {
                            "site_name": "Wye",
                            "farm_name": "Wye",
                            "trial_slug": "wye-niab-wye",
                            "site_code": null,
                            "farm_id": 96,
                            "protocols": [{
                                "harvest_year": 2016,
                                "trial_code": "WW16-9119",
                                "protocol_slug": "6b09d374-b538-11e5-b9b1-f23c9118e215",
                                "title": "Variety x Fungicide"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "WW16-9128",
                                "protocol_slug": "5847c406-0bc0-11e6-a761-f23c9118e215",
                                "title": "NTN G&D Monitoring"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "WOR16-9124",
                                "protocol_slug": "e6c6987e-12cd-11e6-ab73-f23c9118e215",
                                "title": "NTN weed control in Clearfield OSR"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "WW16-9039",
                                "protocol_slug": "f9cef4c4-b478-11e5-953b-f23c9118e215",
                                "title": "WW Variety demonstration plots"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "WW16-9101",
                                "protocol_slug": "86a36d70-b524-11e5-bb9f-f23c9118e215",
                                "title": "Vulpia control options"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "WBN16-9122",
                                "protocol_slug": "83e9301c-11d4-11e6-927d-f23c9118e215",
                                "title": "Winter bean time of sowing x seed rate"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "WW16-9057 WY",
                                "protocol_slug": "ef306b16-16ba-11e6-a69f-f23c9118e215",
                                "title": "NTN (ex-AICC) Leaf Layer fungicide trial - full programme"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "WW16-9118",
                                "protocol_slug": "e37b41b4-1756-11e6-a38c-f23c9118e215",
                                "title": "Nitrogen/PGR interaction in 1st year Winter Wheat"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "WW16-9117",
                                "protocol_slug": "7655479c-176a-11e6-ab73-f23c9118e215",
                                "title": "Fungicide chemistry timing placement in Winter Wheat"
                            }, {
                                "harvest_year": 2016,
                                "trial_code": "WW16-9057 BE",
                                "protocol_slug": "37369354-1c33-11e6-b123-f23c9118e215",
                                "title": "NTN (ex-AICC) Leaf Layer fungicide trial - full programme"
                            }],
                            "farm_slug": "niab-niab-niab-wye"
                        }
                    }]
                }
            }
        ]
    }

}]);
